// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies
// @generated from protobuf file "apl.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ShamanTotems_TotemType } from "./shaman";
import { FeralDruid_Rotation_AplType } from "./druid";
import { UnitReference } from "./common";
import { ActionID } from "./common";
import { Cooldowns } from "./common";
// Rotation options are based heavily on APL. See https://github.com/simulationcraft/simc/wiki/ActionLists.

/**
 * @generated from protobuf message proto.APLRotation
 */
export interface APLRotation {
    /**
     * @generated from protobuf field: proto.APLRotation.Type type = 3;
     */
    type: APLRotation_Type;
    /**
     * @generated from protobuf field: proto.SimpleRotation simple = 4;
     */
    simple?: SimpleRotation;
    /**
     * @generated from protobuf field: repeated proto.APLPrepullAction prepull_actions = 1;
     */
    prepullActions: APLPrepullAction[];
    /**
     * @generated from protobuf field: repeated proto.APLListItem priority_list = 2;
     */
    priorityList: APLListItem[];
}
/**
 * @generated from protobuf enum proto.APLRotation.Type
 */
export enum APLRotation_Type {
    /**
     * @generated from protobuf enum value: TypeUnknown = 0;
     */
    TypeUnknown = 0,
    /**
     * @generated from protobuf enum value: TypeAuto = 1;
     */
    TypeAuto = 1,
    /**
     * @generated from protobuf enum value: TypeSimple = 2;
     */
    TypeSimple = 2,
    /**
     * @generated from protobuf enum value: TypeAPL = 3;
     */
    TypeAPL = 3,
    /**
     * @generated from protobuf enum value: TypeLegacy = 4;
     */
    TypeLegacy = 4
}
/**
 * @generated from protobuf message proto.SimpleRotation
 */
export interface SimpleRotation {
    /**
     * @generated from protobuf field: string spec_rotation_json = 1;
     */
    specRotationJson: string;
    /**
     * @generated from protobuf field: proto.Cooldowns cooldowns = 2;
     */
    cooldowns?: Cooldowns;
}
/**
 * @generated from protobuf message proto.APLPrepullAction
 */
export interface APLPrepullAction {
    /**
     * @generated from protobuf field: proto.APLAction action = 1;
     */
    action?: APLAction;
    /**
     * @generated from protobuf field: proto.APLValue do_at_value = 4;
     */
    doAtValue?: APLValue; // When to perform this prepull action. Should be a negative value.
    /**
     * @generated from protobuf field: bool hide = 3;
     */
    hide: boolean; // Causes this item to be ignored.
}
/**
 * @generated from protobuf message proto.APLListItem
 */
export interface APLListItem {
    /**
     * @generated from protobuf field: bool hide = 1;
     */
    hide: boolean; // Causes this item to be ignored.
    /**
     * @generated from protobuf field: string notes = 2;
     */
    notes: string; // Comments for the reader.
    /**
     * @generated from protobuf field: proto.APLAction action = 3;
     */
    action?: APLAction; // The action to be performed.
}
/**
 * NextIndex: 20
 *
 * @generated from protobuf message proto.APLAction
 */
export interface APLAction {
    /**
     * @generated from protobuf field: proto.APLValue condition = 1;
     */
    condition?: APLValue; // If set, action will only execute if value is true or != 0.
    /**
     * @generated from protobuf oneof: action
     */
    action: {
        oneofKind: "castSpell";
        /**
         * Casting
         *
         * @generated from protobuf field: proto.APLActionCastSpell cast_spell = 3;
         */
        castSpell: APLActionCastSpell;
    } | {
        oneofKind: "channelSpell";
        /**
         * @generated from protobuf field: proto.APLActionChannelSpell channel_spell = 16;
         */
        channelSpell: APLActionChannelSpell;
    } | {
        oneofKind: "multidot";
        /**
         * @generated from protobuf field: proto.APLActionMultidot multidot = 8;
         */
        multidot: APLActionMultidot;
    } | {
        oneofKind: "multishield";
        /**
         * @generated from protobuf field: proto.APLActionMultishield multishield = 12;
         */
        multishield: APLActionMultishield;
    } | {
        oneofKind: "autocastOtherCooldowns";
        /**
         * @generated from protobuf field: proto.APLActionAutocastOtherCooldowns autocast_other_cooldowns = 7;
         */
        autocastOtherCooldowns: APLActionAutocastOtherCooldowns;
    } | {
        oneofKind: "wait";
        /**
         * Timing
         *
         * @generated from protobuf field: proto.APLActionWait wait = 4;
         */
        wait: APLActionWait;
    } | {
        oneofKind: "waitUntil";
        /**
         * @generated from protobuf field: proto.APLActionWaitUntil wait_until = 14;
         */
        waitUntil: APLActionWaitUntil;
    } | {
        oneofKind: "schedule";
        /**
         * @generated from protobuf field: proto.APLActionSchedule schedule = 15;
         */
        schedule: APLActionSchedule;
    } | {
        oneofKind: "sequence";
        /**
         * Sequences
         *
         * @generated from protobuf field: proto.APLActionSequence sequence = 2;
         */
        sequence: APLActionSequence;
    } | {
        oneofKind: "resetSequence";
        /**
         * @generated from protobuf field: proto.APLActionResetSequence reset_sequence = 5;
         */
        resetSequence: APLActionResetSequence;
    } | {
        oneofKind: "strictSequence";
        /**
         * @generated from protobuf field: proto.APLActionStrictSequence strict_sequence = 6;
         */
        strictSequence: APLActionStrictSequence;
    } | {
        oneofKind: "changeTarget";
        /**
         * Misc
         *
         * @generated from protobuf field: proto.APLActionChangeTarget change_target = 9;
         */
        changeTarget: APLActionChangeTarget;
    } | {
        oneofKind: "activateAura";
        /**
         * @generated from protobuf field: proto.APLActionActivateAura activate_aura = 13;
         */
        activateAura: APLActionActivateAura;
    } | {
        oneofKind: "cancelAura";
        /**
         * @generated from protobuf field: proto.APLActionCancelAura cancel_aura = 10;
         */
        cancelAura: APLActionCancelAura;
    } | {
        oneofKind: "triggerIcd";
        /**
         * @generated from protobuf field: proto.APLActionTriggerICD trigger_icd = 11;
         */
        triggerIcd: APLActionTriggerICD;
    } | {
        oneofKind: "itemSwap";
        /**
         * @generated from protobuf field: proto.APLActionItemSwap item_swap = 17;
         */
        itemSwap: APLActionItemSwap;
    } | {
        oneofKind: "catOptimalRotationAction";
        /**
         * Class or Spec-specific actions
         *
         * @generated from protobuf field: proto.APLActionCatOptimalRotationAction cat_optimal_rotation_action = 18;
         */
        catOptimalRotationAction: APLActionCatOptimalRotationAction;
    } | {
        oneofKind: "customRotation";
        /**
         * Internal use only, not exposed in UI.
         *
         * @generated from protobuf field: proto.APLActionCustomRotation custom_rotation = 19;
         */
        customRotation: APLActionCustomRotation;
    } | {
        oneofKind: undefined;
    };
}
/**
 * NextIndex: 66
 *
 * @generated from protobuf message proto.APLValue
 */
export interface APLValue {
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "const";
        /**
         * Operators
         *
         * @generated from protobuf field: proto.APLValueConst const = 1;
         */
        const: APLValueConst;
    } | {
        oneofKind: "and";
        /**
         * @generated from protobuf field: proto.APLValueAnd and = 2;
         */
        and: APLValueAnd;
    } | {
        oneofKind: "or";
        /**
         * @generated from protobuf field: proto.APLValueOr or = 3;
         */
        or: APLValueOr;
    } | {
        oneofKind: "not";
        /**
         * @generated from protobuf field: proto.APLValueNot not = 4;
         */
        not: APLValueNot;
    } | {
        oneofKind: "cmp";
        /**
         * @generated from protobuf field: proto.APLValueCompare cmp = 5;
         */
        cmp: APLValueCompare;
    } | {
        oneofKind: "math";
        /**
         * @generated from protobuf field: proto.APLValueMath math = 38;
         */
        math: APLValueMath;
    } | {
        oneofKind: "max";
        /**
         * @generated from protobuf field: proto.APLValueMax max = 47;
         */
        max: APLValueMax;
    } | {
        oneofKind: "min";
        /**
         * @generated from protobuf field: proto.APLValueMin min = 48;
         */
        min: APLValueMin;
    } | {
        oneofKind: "currentTime";
        /**
         * Encounter values
         *
         * @generated from protobuf field: proto.APLValueCurrentTime current_time = 7;
         */
        currentTime: APLValueCurrentTime;
    } | {
        oneofKind: "currentTimePercent";
        /**
         * @generated from protobuf field: proto.APLValueCurrentTimePercent current_time_percent = 8;
         */
        currentTimePercent: APLValueCurrentTimePercent;
    } | {
        oneofKind: "remainingTime";
        /**
         * @generated from protobuf field: proto.APLValueRemainingTime remaining_time = 9;
         */
        remainingTime: APLValueRemainingTime;
    } | {
        oneofKind: "remainingTimePercent";
        /**
         * @generated from protobuf field: proto.APLValueRemainingTimePercent remaining_time_percent = 10;
         */
        remainingTimePercent: APLValueRemainingTimePercent;
    } | {
        oneofKind: "isExecutePhase";
        /**
         * @generated from protobuf field: proto.APLValueIsExecutePhase is_execute_phase = 41;
         */
        isExecutePhase: APLValueIsExecutePhase;
    } | {
        oneofKind: "numberTargets";
        /**
         * @generated from protobuf field: proto.APLValueNumberTargets number_targets = 28;
         */
        numberTargets: APLValueNumberTargets;
    } | {
        oneofKind: "bossSpellTimeToReady";
        /**
         * Boss values
         *
         * @generated from protobuf field: proto.APLValueBossSpellTimeToReady boss_spell_time_to_ready = 64;
         */
        bossSpellTimeToReady: APLValueBossSpellTimeToReady;
    } | {
        oneofKind: "bossSpellIsCasting";
        /**
         * @generated from protobuf field: proto.APLValueBossSpellIsCasting boss_spell_is_casting = 65;
         */
        bossSpellIsCasting: APLValueBossSpellIsCasting;
    } | {
        oneofKind: "currentHealth";
        /**
         * Resource values
         *
         * @generated from protobuf field: proto.APLValueCurrentHealth current_health = 26;
         */
        currentHealth: APLValueCurrentHealth;
    } | {
        oneofKind: "currentHealthPercent";
        /**
         * @generated from protobuf field: proto.APLValueCurrentHealthPercent current_health_percent = 27;
         */
        currentHealthPercent: APLValueCurrentHealthPercent;
    } | {
        oneofKind: "currentMana";
        /**
         * @generated from protobuf field: proto.APLValueCurrentMana current_mana = 11;
         */
        currentMana: APLValueCurrentMana;
    } | {
        oneofKind: "currentManaPercent";
        /**
         * @generated from protobuf field: proto.APLValueCurrentManaPercent current_mana_percent = 12;
         */
        currentManaPercent: APLValueCurrentManaPercent;
    } | {
        oneofKind: "currentRage";
        /**
         * @generated from protobuf field: proto.APLValueCurrentRage current_rage = 14;
         */
        currentRage: APLValueCurrentRage;
    } | {
        oneofKind: "currentEnergy";
        /**
         * @generated from protobuf field: proto.APLValueCurrentEnergy current_energy = 15;
         */
        currentEnergy: APLValueCurrentEnergy;
    } | {
        oneofKind: "currentComboPoints";
        /**
         * @generated from protobuf field: proto.APLValueCurrentComboPoints current_combo_points = 16;
         */
        currentComboPoints: APLValueCurrentComboPoints;
    } | {
        oneofKind: "currentRunicPower";
        /**
         * @generated from protobuf field: proto.APLValueCurrentRunicPower current_runic_power = 25;
         */
        currentRunicPower: APLValueCurrentRunicPower;
    } | {
        oneofKind: "currentRuneCount";
        /**
         * Rune Resource values
         *
         * @generated from protobuf field: proto.APLValueCurrentRuneCount current_rune_count = 29;
         */
        currentRuneCount: APLValueCurrentRuneCount;
    } | {
        oneofKind: "currentNonDeathRuneCount";
        /**
         * @generated from protobuf field: proto.APLValueCurrentNonDeathRuneCount current_non_death_rune_count = 34;
         */
        currentNonDeathRuneCount: APLValueCurrentNonDeathRuneCount;
    } | {
        oneofKind: "currentRuneDeath";
        /**
         * @generated from protobuf field: proto.APLValueCurrentRuneDeath current_rune_death = 30;
         */
        currentRuneDeath: APLValueCurrentRuneDeath;
    } | {
        oneofKind: "currentRuneActive";
        /**
         * @generated from protobuf field: proto.APLValueCurrentRuneActive current_rune_active = 31;
         */
        currentRuneActive: APLValueCurrentRuneActive;
    } | {
        oneofKind: "runeCooldown";
        /**
         * @generated from protobuf field: proto.APLValueRuneCooldown rune_cooldown = 32;
         */
        runeCooldown: APLValueRuneCooldown;
    } | {
        oneofKind: "nextRuneCooldown";
        /**
         * @generated from protobuf field: proto.APLValueNextRuneCooldown next_rune_cooldown = 33;
         */
        nextRuneCooldown: APLValueNextRuneCooldown;
    } | {
        oneofKind: "runeSlotCooldown";
        /**
         * @generated from protobuf field: proto.APLValueRuneSlotCooldown rune_slot_cooldown = 53;
         */
        runeSlotCooldown: APLValueRuneSlotCooldown;
    } | {
        oneofKind: "runeGrace";
        /**
         * @generated from protobuf field: proto.APLValueRuneGrace rune_grace = 54;
         */
        runeGrace: APLValueRuneGrace;
    } | {
        oneofKind: "runeSlotGrace";
        /**
         * @generated from protobuf field: proto.APLValueRuneSlotGrace rune_slot_grace = 55;
         */
        runeSlotGrace: APLValueRuneSlotGrace;
    } | {
        oneofKind: "gcdIsReady";
        /**
         * GCD values
         *
         * @generated from protobuf field: proto.APLValueGCDIsReady gcd_is_ready = 17;
         */
        gcdIsReady: APLValueGCDIsReady;
    } | {
        oneofKind: "gcdTimeToReady";
        /**
         * @generated from protobuf field: proto.APLValueGCDTimeToReady gcd_time_to_ready = 18;
         */
        gcdTimeToReady: APLValueGCDTimeToReady;
    } | {
        oneofKind: "autoTimeToNext";
        /**
         * Autoattack values
         *
         * @generated from protobuf field: proto.APLValueAutoTimeToNext auto_time_to_next = 40;
         */
        autoTimeToNext: APLValueAutoTimeToNext;
    } | {
        oneofKind: "spellCanCast";
        /**
         * Spell values
         *
         * @generated from protobuf field: proto.APLValueSpellCanCast spell_can_cast = 19;
         */
        spellCanCast: APLValueSpellCanCast;
    } | {
        oneofKind: "spellIsReady";
        /**
         * @generated from protobuf field: proto.APLValueSpellIsReady spell_is_ready = 20;
         */
        spellIsReady: APLValueSpellIsReady;
    } | {
        oneofKind: "spellTimeToReady";
        /**
         * @generated from protobuf field: proto.APLValueSpellTimeToReady spell_time_to_ready = 21;
         */
        spellTimeToReady: APLValueSpellTimeToReady;
    } | {
        oneofKind: "spellCastTime";
        /**
         * @generated from protobuf field: proto.APLValueSpellCastTime spell_cast_time = 35;
         */
        spellCastTime: APLValueSpellCastTime;
    } | {
        oneofKind: "spellTravelTime";
        /**
         * @generated from protobuf field: proto.APLValueSpellTravelTime spell_travel_time = 37;
         */
        spellTravelTime: APLValueSpellTravelTime;
    } | {
        oneofKind: "spellCpm";
        /**
         * @generated from protobuf field: proto.APLValueSpellCPM spell_cpm = 42;
         */
        spellCpm: APLValueSpellCPM;
    } | {
        oneofKind: "spellIsChanneling";
        /**
         * @generated from protobuf field: proto.APLValueSpellIsChanneling spell_is_channeling = 56;
         */
        spellIsChanneling: APLValueSpellIsChanneling;
    } | {
        oneofKind: "spellChanneledTicks";
        /**
         * @generated from protobuf field: proto.APLValueSpellChanneledTicks spell_channeled_ticks = 57;
         */
        spellChanneledTicks: APLValueSpellChanneledTicks;
    } | {
        oneofKind: "spellCurrentCost";
        /**
         * @generated from protobuf field: proto.APLValueSpellCurrentCost spell_current_cost = 62;
         */
        spellCurrentCost: APLValueSpellCurrentCost;
    } | {
        oneofKind: "auraIsActive";
        /**
         * Aura values
         *
         * @generated from protobuf field: proto.APLValueAuraIsActive aura_is_active = 22;
         */
        auraIsActive: APLValueAuraIsActive;
    } | {
        oneofKind: "auraIsActiveWithReactionTime";
        /**
         * @generated from protobuf field: proto.APLValueAuraIsActiveWithReactionTime aura_is_active_with_reaction_time = 50;
         */
        auraIsActiveWithReactionTime: APLValueAuraIsActiveWithReactionTime;
    } | {
        oneofKind: "auraRemainingTime";
        /**
         * @generated from protobuf field: proto.APLValueAuraRemainingTime aura_remaining_time = 23;
         */
        auraRemainingTime: APLValueAuraRemainingTime;
    } | {
        oneofKind: "auraNumStacks";
        /**
         * @generated from protobuf field: proto.APLValueAuraNumStacks aura_num_stacks = 24;
         */
        auraNumStacks: APLValueAuraNumStacks;
    } | {
        oneofKind: "auraInternalCooldown";
        /**
         * @generated from protobuf field: proto.APLValueAuraInternalCooldown aura_internal_cooldown = 39;
         */
        auraInternalCooldown: APLValueAuraInternalCooldown;
    } | {
        oneofKind: "auraIcdIsReadyWithReactionTime";
        /**
         * @generated from protobuf field: proto.APLValueAuraICDIsReadyWithReactionTime aura_icd_is_ready_with_reaction_time = 51;
         */
        auraIcdIsReadyWithReactionTime: APLValueAuraICDIsReadyWithReactionTime;
    } | {
        oneofKind: "auraShouldRefresh";
        /**
         * @generated from protobuf field: proto.APLValueAuraShouldRefresh aura_should_refresh = 43;
         */
        auraShouldRefresh: APLValueAuraShouldRefresh;
    } | {
        oneofKind: "dotIsActive";
        /**
         * Dot values
         *
         * @generated from protobuf field: proto.APLValueDotIsActive dot_is_active = 6;
         */
        dotIsActive: APLValueDotIsActive;
    } | {
        oneofKind: "dotRemainingTime";
        /**
         * @generated from protobuf field: proto.APLValueDotRemainingTime dot_remaining_time = 13;
         */
        dotRemainingTime: APLValueDotRemainingTime;
    } | {
        oneofKind: "sequenceIsComplete";
        /**
         * Sequence values
         *
         * @generated from protobuf field: proto.APLValueSequenceIsComplete sequence_is_complete = 44;
         */
        sequenceIsComplete: APLValueSequenceIsComplete;
    } | {
        oneofKind: "sequenceIsReady";
        /**
         * @generated from protobuf field: proto.APLValueSequenceIsReady sequence_is_ready = 45;
         */
        sequenceIsReady: APLValueSequenceIsReady;
    } | {
        oneofKind: "sequenceTimeToReady";
        /**
         * @generated from protobuf field: proto.APLValueSequenceTimeToReady sequence_time_to_ready = 46;
         */
        sequenceTimeToReady: APLValueSequenceTimeToReady;
    } | {
        oneofKind: "channelClipDelay";
        /**
         * Properties
         *
         * @generated from protobuf field: proto.APLValueChannelClipDelay channel_clip_delay = 58;
         */
        channelClipDelay: APLValueChannelClipDelay;
    } | {
        oneofKind: "frontOfTarget";
        /**
         * @generated from protobuf field: proto.APLValueFrontOfTarget front_of_target = 63;
         */
        frontOfTarget: APLValueFrontOfTarget;
    } | {
        oneofKind: "totemRemainingTime";
        /**
         * Class or Spec-specific values
         *
         * @generated from protobuf field: proto.APLValueTotemRemainingTime totem_remaining_time = 49;
         */
        totemRemainingTime: APLValueTotemRemainingTime;
    } | {
        oneofKind: "catExcessEnergy";
        /**
         * @generated from protobuf field: proto.APLValueCatExcessEnergy cat_excess_energy = 52;
         */
        catExcessEnergy: APLValueCatExcessEnergy;
    } | {
        oneofKind: "catNewSavageRoarDuration";
        /**
         * @generated from protobuf field: proto.APLValueCatNewSavageRoarDuration cat_new_savage_roar_duration = 61;
         */
        catNewSavageRoarDuration: APLValueCatNewSavageRoarDuration;
    } | {
        oneofKind: "warlockShouldRecastDrainSoul";
        /**
         * @generated from protobuf field: proto.APLValueWarlockShouldRecastDrainSoul warlock_should_recast_drain_soul = 59;
         */
        warlockShouldRecastDrainSoul: APLValueWarlockShouldRecastDrainSoul;
    } | {
        oneofKind: "warlockShouldRefreshCorruption";
        /**
         * @generated from protobuf field: proto.APLValueWarlockShouldRefreshCorruption warlock_should_refresh_corruption = 60;
         */
        warlockShouldRefreshCorruption: APLValueWarlockShouldRefreshCorruption;
    } | {
        oneofKind: undefined;
    };
}
// /////////////////////////////////////////////////////////////////////////
//                                 ACTIONS
// /////////////////////////////////////////////////////////////////////////

/**
 * @generated from protobuf message proto.APLActionCastSpell
 */
export interface APLActionCastSpell {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
    /**
     * @generated from protobuf field: proto.UnitReference target = 2;
     */
    target?: UnitReference;
}
/**
 * @generated from protobuf message proto.APLActionChannelSpell
 */
export interface APLActionChannelSpell {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
    /**
     * @generated from protobuf field: proto.UnitReference target = 2;
     */
    target?: UnitReference;
    /**
     * @generated from protobuf field: proto.APLValue interrupt_if = 3;
     */
    interruptIf?: APLValue;
    /**
     * @generated from protobuf field: bool allow_recast = 5;
     */
    allowRecast: boolean;
}
/**
 * @generated from protobuf message proto.APLActionMultidot
 */
export interface APLActionMultidot {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
    /**
     * @generated from protobuf field: int32 max_dots = 2;
     */
    maxDots: number;
    /**
     * @generated from protobuf field: proto.APLValue max_overlap = 3;
     */
    maxOverlap?: APLValue;
}
/**
 * @generated from protobuf message proto.APLActionMultishield
 */
export interface APLActionMultishield {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
    /**
     * @generated from protobuf field: int32 max_shields = 2;
     */
    maxShields: number;
    /**
     * @generated from protobuf field: proto.APLValue max_overlap = 3;
     */
    maxOverlap?: APLValue;
}
/**
 * @generated from protobuf message proto.APLActionAutocastOtherCooldowns
 */
export interface APLActionAutocastOtherCooldowns {
}
/**
 * @generated from protobuf message proto.APLActionWait
 */
export interface APLActionWait {
    /**
     * @generated from protobuf field: proto.APLValue duration = 1;
     */
    duration?: APLValue;
}
/**
 * @generated from protobuf message proto.APLActionWaitUntil
 */
export interface APLActionWaitUntil {
    /**
     * @generated from protobuf field: proto.APLValue condition = 1;
     */
    condition?: APLValue;
}
/**
 * @generated from protobuf message proto.APLActionSchedule
 */
export interface APLActionSchedule {
    /**
     * Comma-separated list of times, e.g. '0s, 30s, 60s'
     *
     * @generated from protobuf field: string schedule = 1;
     */
    schedule: string;
    /**
     * @generated from protobuf field: proto.APLAction inner_action = 2;
     */
    innerAction?: APLAction;
}
/**
 * @generated from protobuf message proto.APLActionSequence
 */
export interface APLActionSequence {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated proto.APLAction actions = 2;
     */
    actions: APLAction[];
}
/**
 * @generated from protobuf message proto.APLActionResetSequence
 */
export interface APLActionResetSequence {
    /**
     * @generated from protobuf field: string sequence_name = 1;
     */
    sequenceName: string;
}
/**
 * @generated from protobuf message proto.APLActionStrictSequence
 */
export interface APLActionStrictSequence {
    /**
     * @generated from protobuf field: repeated proto.APLAction actions = 1;
     */
    actions: APLAction[];
}
/**
 * @generated from protobuf message proto.APLActionChangeTarget
 */
export interface APLActionChangeTarget {
    /**
     * @generated from protobuf field: proto.UnitReference new_target = 1;
     */
    newTarget?: UnitReference;
}
/**
 * @generated from protobuf message proto.APLActionCancelAura
 */
export interface APLActionCancelAura {
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLActionActivateAura
 */
export interface APLActionActivateAura {
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLActionTriggerICD
 */
export interface APLActionTriggerICD {
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLActionItemSwap
 */
export interface APLActionItemSwap {
    /**
     * The set to swap to.
     *
     * @generated from protobuf field: proto.APLActionItemSwap.SwapSet swap_set = 1;
     */
    swapSet: APLActionItemSwap_SwapSet;
}
/**
 * @generated from protobuf enum proto.APLActionItemSwap.SwapSet
 */
export enum APLActionItemSwap_SwapSet {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    Unknown = 0,
    /**
     * @generated from protobuf enum value: Main = 1;
     */
    Main = 1,
    /**
     * @generated from protobuf enum value: Swap1 = 2;
     */
    Swap1 = 2
}
/**
 * @generated from protobuf message proto.APLActionCatOptimalRotationAction
 */
export interface APLActionCatOptimalRotationAction {
    /**
     * @generated from protobuf field: proto.FeralDruid.Rotation.AplType rotation_type = 1;
     */
    rotationType: FeralDruid_Rotation_AplType;
    /**
     * @generated from protobuf field: bool manual_params = 2;
     */
    manualParams: boolean;
    /**
     * @generated from protobuf field: float max_ff_delay = 3;
     */
    maxFfDelay: number;
    /**
     * @generated from protobuf field: float min_roar_offset = 4;
     */
    minRoarOffset: number;
    /**
     * @generated from protobuf field: int32 rip_leeway = 5;
     */
    ripLeeway: number;
    /**
     * @generated from protobuf field: bool use_rake = 6;
     */
    useRake: boolean;
    /**
     * @generated from protobuf field: bool use_bite = 7;
     */
    useBite: boolean;
    /**
     * @generated from protobuf field: float bite_time = 8;
     */
    biteTime: number;
    /**
     * @generated from protobuf field: bool flower_weave = 9;
     */
    flowerWeave: boolean;
}
/**
 * @generated from protobuf message proto.APLActionCustomRotation
 */
export interface APLActionCustomRotation {
}
/**
 * @generated from protobuf message proto.APLValueConst
 */
export interface APLValueConst {
    /**
     * @generated from protobuf field: string val = 1;
     */
    val: string;
}
/**
 * @generated from protobuf message proto.APLValueAnd
 */
export interface APLValueAnd {
    /**
     * @generated from protobuf field: repeated proto.APLValue vals = 1;
     */
    vals: APLValue[];
}
/**
 * @generated from protobuf message proto.APLValueOr
 */
export interface APLValueOr {
    /**
     * @generated from protobuf field: repeated proto.APLValue vals = 1;
     */
    vals: APLValue[];
}
/**
 * @generated from protobuf message proto.APLValueNot
 */
export interface APLValueNot {
    /**
     * @generated from protobuf field: proto.APLValue val = 1;
     */
    val?: APLValue;
}
/**
 * @generated from protobuf message proto.APLValueCompare
 */
export interface APLValueCompare {
    /**
     * @generated from protobuf field: proto.APLValueCompare.ComparisonOperator op = 1;
     */
    op: APLValueCompare_ComparisonOperator;
    /**
     * @generated from protobuf field: proto.APLValue lhs = 2;
     */
    lhs?: APLValue;
    /**
     * @generated from protobuf field: proto.APLValue rhs = 3;
     */
    rhs?: APLValue;
}
/**
 * @generated from protobuf enum proto.APLValueCompare.ComparisonOperator
 */
export enum APLValueCompare_ComparisonOperator {
    /**
     * @generated from protobuf enum value: OpUnknown = 0;
     */
    OpUnknown = 0,
    /**
     * Equals
     *
     * @generated from protobuf enum value: OpEq = 1;
     */
    OpEq = 1,
    /**
     * Not equals
     *
     * @generated from protobuf enum value: OpNe = 2;
     */
    OpNe = 2,
    /**
     * Less than
     *
     * @generated from protobuf enum value: OpLt = 3;
     */
    OpLt = 3,
    /**
     * Less than or equal
     *
     * @generated from protobuf enum value: OpLe = 4;
     */
    OpLe = 4,
    /**
     * Greater than
     *
     * @generated from protobuf enum value: OpGt = 5;
     */
    OpGt = 5,
    /**
     * Greater than or equal
     *
     * @generated from protobuf enum value: OpGe = 6;
     */
    OpGe = 6
}
/**
 * @generated from protobuf message proto.APLValueMath
 */
export interface APLValueMath {
    /**
     * @generated from protobuf field: proto.APLValueMath.MathOperator op = 1;
     */
    op: APLValueMath_MathOperator;
    /**
     * @generated from protobuf field: proto.APLValue lhs = 2;
     */
    lhs?: APLValue;
    /**
     * @generated from protobuf field: proto.APLValue rhs = 3;
     */
    rhs?: APLValue;
}
/**
 * @generated from protobuf enum proto.APLValueMath.MathOperator
 */
export enum APLValueMath_MathOperator {
    /**
     * @generated from protobuf enum value: OpUnknown = 0;
     */
    OpUnknown = 0,
    /**
     * Add
     *
     * @generated from protobuf enum value: OpAdd = 1;
     */
    OpAdd = 1,
    /**
     * Subtract
     *
     * @generated from protobuf enum value: OpSub = 2;
     */
    OpSub = 2,
    /**
     * Multiply
     *
     * @generated from protobuf enum value: OpMul = 3;
     */
    OpMul = 3,
    /**
     * Divide
     *
     * @generated from protobuf enum value: OpDiv = 4;
     */
    OpDiv = 4
}
/**
 * @generated from protobuf message proto.APLValueMax
 */
export interface APLValueMax {
    /**
     * @generated from protobuf field: repeated proto.APLValue vals = 1;
     */
    vals: APLValue[];
}
/**
 * @generated from protobuf message proto.APLValueMin
 */
export interface APLValueMin {
    /**
     * @generated from protobuf field: repeated proto.APLValue vals = 1;
     */
    vals: APLValue[];
}
/**
 * @generated from protobuf message proto.APLValueCurrentTime
 */
export interface APLValueCurrentTime {
}
/**
 * @generated from protobuf message proto.APLValueCurrentTimePercent
 */
export interface APLValueCurrentTimePercent {
}
/**
 * @generated from protobuf message proto.APLValueRemainingTime
 */
export interface APLValueRemainingTime {
}
/**
 * @generated from protobuf message proto.APLValueRemainingTimePercent
 */
export interface APLValueRemainingTimePercent {
}
/**
 * @generated from protobuf message proto.APLValueNumberTargets
 */
export interface APLValueNumberTargets {
}
/**
 * @generated from protobuf message proto.APLValueIsExecutePhase
 */
export interface APLValueIsExecutePhase {
    /**
     * @generated from protobuf field: proto.APLValueIsExecutePhase.ExecutePhaseThreshold threshold = 1;
     */
    threshold: APLValueIsExecutePhase_ExecutePhaseThreshold;
}
/**
 * @generated from protobuf enum proto.APLValueIsExecutePhase.ExecutePhaseThreshold
 */
export enum APLValueIsExecutePhase_ExecutePhaseThreshold {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    Unknown = 0,
    /**
     * @generated from protobuf enum value: E20 = 1;
     */
    E20 = 1,
    /**
     * @generated from protobuf enum value: E25 = 2;
     */
    E25 = 2,
    /**
     * @generated from protobuf enum value: E35 = 3;
     */
    E35 = 3
}
/**
 * @generated from protobuf message proto.APLValueBossSpellTimeToReady
 */
export interface APLValueBossSpellTimeToReady {
    /**
     * @generated from protobuf field: proto.UnitReference target_unit = 1;
     */
    targetUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 2;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueBossSpellIsCasting
 */
export interface APLValueBossSpellIsCasting {
    /**
     * @generated from protobuf field: proto.UnitReference target_unit = 1;
     */
    targetUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 2;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueCurrentHealth
 */
export interface APLValueCurrentHealth {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 1;
     */
    sourceUnit?: UnitReference;
}
/**
 * @generated from protobuf message proto.APLValueCurrentHealthPercent
 */
export interface APLValueCurrentHealthPercent {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 1;
     */
    sourceUnit?: UnitReference;
}
/**
 * @generated from protobuf message proto.APLValueCurrentMana
 */
export interface APLValueCurrentMana {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 1;
     */
    sourceUnit?: UnitReference;
}
/**
 * @generated from protobuf message proto.APLValueCurrentManaPercent
 */
export interface APLValueCurrentManaPercent {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 1;
     */
    sourceUnit?: UnitReference;
}
/**
 * @generated from protobuf message proto.APLValueCurrentRage
 */
export interface APLValueCurrentRage {
}
/**
 * @generated from protobuf message proto.APLValueCurrentEnergy
 */
export interface APLValueCurrentEnergy {
}
/**
 * @generated from protobuf message proto.APLValueCurrentComboPoints
 */
export interface APLValueCurrentComboPoints {
}
/**
 * @generated from protobuf message proto.APLValueCurrentRunicPower
 */
export interface APLValueCurrentRunicPower {
}
/**
 * @generated from protobuf message proto.APLValueCurrentRuneCount
 */
export interface APLValueCurrentRuneCount {
    /**
     * @generated from protobuf field: proto.APLValueRuneType rune_type = 1;
     */
    runeType: APLValueRuneType;
}
/**
 * @generated from protobuf message proto.APLValueCurrentNonDeathRuneCount
 */
export interface APLValueCurrentNonDeathRuneCount {
    /**
     * @generated from protobuf field: proto.APLValueRuneType rune_type = 1;
     */
    runeType: APLValueRuneType;
}
/**
 * @generated from protobuf message proto.APLValueCurrentRuneDeath
 */
export interface APLValueCurrentRuneDeath {
    /**
     * @generated from protobuf field: proto.APLValueRuneSlot rune_slot = 1;
     */
    runeSlot: APLValueRuneSlot;
}
/**
 * @generated from protobuf message proto.APLValueCurrentRuneActive
 */
export interface APLValueCurrentRuneActive {
    /**
     * @generated from protobuf field: proto.APLValueRuneSlot rune_slot = 1;
     */
    runeSlot: APLValueRuneSlot;
}
/**
 * @generated from protobuf message proto.APLValueRuneCooldown
 */
export interface APLValueRuneCooldown {
    /**
     * @generated from protobuf field: proto.APLValueRuneType rune_type = 1;
     */
    runeType: APLValueRuneType;
}
/**
 * @generated from protobuf message proto.APLValueNextRuneCooldown
 */
export interface APLValueNextRuneCooldown {
    /**
     * @generated from protobuf field: proto.APLValueRuneType rune_type = 1;
     */
    runeType: APLValueRuneType;
}
/**
 * @generated from protobuf message proto.APLValueRuneSlotCooldown
 */
export interface APLValueRuneSlotCooldown {
    /**
     * @generated from protobuf field: proto.APLValueRuneSlot rune_slot = 1;
     */
    runeSlot: APLValueRuneSlot;
}
/**
 * @generated from protobuf message proto.APLValueRuneGrace
 */
export interface APLValueRuneGrace {
    /**
     * @generated from protobuf field: proto.APLValueRuneType rune_type = 1;
     */
    runeType: APLValueRuneType;
}
/**
 * @generated from protobuf message proto.APLValueRuneSlotGrace
 */
export interface APLValueRuneSlotGrace {
    /**
     * @generated from protobuf field: proto.APLValueRuneType rune_slot = 1;
     */
    runeSlot: APLValueRuneType;
}
/**
 * @generated from protobuf message proto.APLValueGCDIsReady
 */
export interface APLValueGCDIsReady {
}
/**
 * @generated from protobuf message proto.APLValueGCDTimeToReady
 */
export interface APLValueGCDTimeToReady {
}
/**
 * @generated from protobuf message proto.APLValueAutoTimeToNext
 */
export interface APLValueAutoTimeToNext {
}
/**
 * @generated from protobuf message proto.APLValueSpellCanCast
 */
export interface APLValueSpellCanCast {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSpellIsReady
 */
export interface APLValueSpellIsReady {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSpellTimeToReady
 */
export interface APLValueSpellTimeToReady {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSpellCastTime
 */
export interface APLValueSpellCastTime {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueChannelClipDelay
 */
export interface APLValueChannelClipDelay {
}
/**
 * @generated from protobuf message proto.APLValueFrontOfTarget
 */
export interface APLValueFrontOfTarget {
}
/**
 * @generated from protobuf message proto.APLValueSpellTravelTime
 */
export interface APLValueSpellTravelTime {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSpellCPM
 */
export interface APLValueSpellCPM {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSpellIsChanneling
 */
export interface APLValueSpellIsChanneling {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSpellChanneledTicks
 */
export interface APLValueSpellChanneledTicks {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSpellCurrentCost
 */
export interface APLValueSpellCurrentCost {
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueAuraIsActive
 */
export interface APLValueAuraIsActive {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 2;
     */
    sourceUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueAuraIsActiveWithReactionTime
 */
export interface APLValueAuraIsActiveWithReactionTime {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 2;
     */
    sourceUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueAuraRemainingTime
 */
export interface APLValueAuraRemainingTime {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 2;
     */
    sourceUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueAuraNumStacks
 */
export interface APLValueAuraNumStacks {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 2;
     */
    sourceUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueAuraInternalCooldown
 */
export interface APLValueAuraInternalCooldown {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 2;
     */
    sourceUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueAuraICDIsReadyWithReactionTime
 */
export interface APLValueAuraICDIsReadyWithReactionTime {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 2;
     */
    sourceUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueAuraShouldRefresh
 */
export interface APLValueAuraShouldRefresh {
    /**
     * @generated from protobuf field: proto.UnitReference source_unit = 2;
     */
    sourceUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID aura_id = 1;
     */
    auraId?: ActionID;
    /**
     * @generated from protobuf field: proto.APLValue max_overlap = 3;
     */
    maxOverlap?: APLValue;
}
/**
 * @generated from protobuf message proto.APLValueDotIsActive
 */
export interface APLValueDotIsActive {
    /**
     * @generated from protobuf field: proto.UnitReference target_unit = 2;
     */
    targetUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueDotRemainingTime
 */
export interface APLValueDotRemainingTime {
    /**
     * @generated from protobuf field: proto.UnitReference target_unit = 2;
     */
    targetUnit?: UnitReference;
    /**
     * @generated from protobuf field: proto.ActionID spell_id = 1;
     */
    spellId?: ActionID;
}
/**
 * @generated from protobuf message proto.APLValueSequenceIsComplete
 */
export interface APLValueSequenceIsComplete {
    /**
     * @generated from protobuf field: string sequence_name = 1;
     */
    sequenceName: string;
}
/**
 * @generated from protobuf message proto.APLValueSequenceIsReady
 */
export interface APLValueSequenceIsReady {
    /**
     * @generated from protobuf field: string sequence_name = 1;
     */
    sequenceName: string;
}
/**
 * @generated from protobuf message proto.APLValueSequenceTimeToReady
 */
export interface APLValueSequenceTimeToReady {
    /**
     * @generated from protobuf field: string sequence_name = 1;
     */
    sequenceName: string;
}
/**
 * @generated from protobuf message proto.APLValueTotemRemainingTime
 */
export interface APLValueTotemRemainingTime {
    /**
     * @generated from protobuf field: proto.ShamanTotems.TotemType totem_type = 1;
     */
    totemType: ShamanTotems_TotemType;
}
/**
 * @generated from protobuf message proto.APLValueCatExcessEnergy
 */
export interface APLValueCatExcessEnergy {
}
/**
 * @generated from protobuf message proto.APLValueCatNewSavageRoarDuration
 */
export interface APLValueCatNewSavageRoarDuration {
}
/**
 * @generated from protobuf message proto.APLValueWarlockShouldRecastDrainSoul
 */
export interface APLValueWarlockShouldRecastDrainSoul {
}
/**
 * @generated from protobuf message proto.APLValueWarlockShouldRefreshCorruption
 */
export interface APLValueWarlockShouldRefreshCorruption {
    /**
     * @generated from protobuf field: proto.UnitReference target_unit = 1;
     */
    targetUnit?: UnitReference;
}
// /////////////////////////////////////////////////////////////////////////
//                                  VALUES
// /////////////////////////////////////////////////////////////////////////

/**
 * @generated from protobuf enum proto.APLValueType
 */
export enum APLValueType {
    /**
     * @generated from protobuf enum value: ValueTypeUnknown = 0;
     */
    ValueTypeUnknown = 0,
    /**
     * @generated from protobuf enum value: ValueTypeBool = 1;
     */
    ValueTypeBool = 1,
    /**
     * @generated from protobuf enum value: ValueTypeInt = 2;
     */
    ValueTypeInt = 2,
    /**
     * @generated from protobuf enum value: ValueTypeFloat = 3;
     */
    ValueTypeFloat = 3,
    /**
     * @generated from protobuf enum value: ValueTypeDuration = 4;
     */
    ValueTypeDuration = 4,
    /**
     * @generated from protobuf enum value: ValueTypeString = 5;
     */
    ValueTypeString = 5
}
/**
 * @generated from protobuf enum proto.APLValueRuneType
 */
export enum APLValueRuneType {
    /**
     * @generated from protobuf enum value: RuneUnknown = 0;
     */
    RuneUnknown = 0,
    /**
     * @generated from protobuf enum value: RuneBlood = 1;
     */
    RuneBlood = 1,
    /**
     * @generated from protobuf enum value: RuneFrost = 2;
     */
    RuneFrost = 2,
    /**
     * @generated from protobuf enum value: RuneUnholy = 3;
     */
    RuneUnholy = 3,
    /**
     * @generated from protobuf enum value: RuneDeath = 4;
     */
    RuneDeath = 4
}
/**
 * @generated from protobuf enum proto.APLValueRuneSlot
 */
export enum APLValueRuneSlot {
    /**
     * @generated from protobuf enum value: SlotUnknown = 0;
     */
    SlotUnknown = 0,
    /**
     * @generated from protobuf enum value: SlotLeftBlood = 1;
     */
    SlotLeftBlood = 1,
    /**
     * @generated from protobuf enum value: SlotRightBlood = 2;
     */
    SlotRightBlood = 2,
    /**
     * @generated from protobuf enum value: SlotLeftFrost = 3;
     */
    SlotLeftFrost = 3,
    /**
     * @generated from protobuf enum value: SlotRightFrost = 4;
     */
    SlotRightFrost = 4,
    /**
     * @generated from protobuf enum value: SlotLeftUnholy = 5;
     */
    SlotLeftUnholy = 5,
    /**
     * @generated from protobuf enum value: SlotRightUnholy = 6;
     */
    SlotRightUnholy = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class APLRotation$Type extends MessageType<APLRotation> {
    constructor() {
        super("proto.APLRotation", [
            { no: 3, name: "type", kind: "enum", T: () => ["proto.APLRotation.Type", APLRotation_Type] },
            { no: 4, name: "simple", kind: "message", T: () => SimpleRotation },
            { no: 1, name: "prepull_actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLPrepullAction },
            { no: 2, name: "priority_list", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLListItem }
        ]);
    }
    create(value?: PartialMessage<APLRotation>): APLRotation {
        const message = { type: 0, prepullActions: [], priorityList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLRotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLRotation): APLRotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLRotation.Type type */ 3:
                    message.type = reader.int32();
                    break;
                case /* proto.SimpleRotation simple */ 4:
                    message.simple = SimpleRotation.internalBinaryRead(reader, reader.uint32(), options, message.simple);
                    break;
                case /* repeated proto.APLPrepullAction prepull_actions */ 1:
                    message.prepullActions.push(APLPrepullAction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.APLListItem priority_list */ 2:
                    message.priorityList.push(APLListItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLRotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLRotation.Type type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* proto.SimpleRotation simple = 4; */
        if (message.simple)
            SimpleRotation.internalBinaryWrite(message.simple, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.APLPrepullAction prepull_actions = 1; */
        for (let i = 0; i < message.prepullActions.length; i++)
            APLPrepullAction.internalBinaryWrite(message.prepullActions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.APLListItem priority_list = 2; */
        for (let i = 0; i < message.priorityList.length; i++)
            APLListItem.internalBinaryWrite(message.priorityList[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLRotation
 */
export const APLRotation = new APLRotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimpleRotation$Type extends MessageType<SimpleRotation> {
    constructor() {
        super("proto.SimpleRotation", [
            { no: 1, name: "spec_rotation_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cooldowns", kind: "message", T: () => Cooldowns }
        ]);
    }
    create(value?: PartialMessage<SimpleRotation>): SimpleRotation {
        const message = { specRotationJson: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimpleRotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimpleRotation): SimpleRotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string spec_rotation_json */ 1:
                    message.specRotationJson = reader.string();
                    break;
                case /* proto.Cooldowns cooldowns */ 2:
                    message.cooldowns = Cooldowns.internalBinaryRead(reader, reader.uint32(), options, message.cooldowns);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimpleRotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string spec_rotation_json = 1; */
        if (message.specRotationJson !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.specRotationJson);
        /* proto.Cooldowns cooldowns = 2; */
        if (message.cooldowns)
            Cooldowns.internalBinaryWrite(message.cooldowns, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimpleRotation
 */
export const SimpleRotation = new SimpleRotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLPrepullAction$Type extends MessageType<APLPrepullAction> {
    constructor() {
        super("proto.APLPrepullAction", [
            { no: 1, name: "action", kind: "message", T: () => APLAction },
            { no: 4, name: "do_at_value", kind: "message", T: () => APLValue },
            { no: 3, name: "hide", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<APLPrepullAction>): APLPrepullAction {
        const message = { hide: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLPrepullAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLPrepullAction): APLPrepullAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLAction action */ 1:
                    message.action = APLAction.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                case /* proto.APLValue do_at_value */ 4:
                    message.doAtValue = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.doAtValue);
                    break;
                case /* bool hide */ 3:
                    message.hide = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLPrepullAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLAction action = 1; */
        if (message.action)
            APLAction.internalBinaryWrite(message.action, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValue do_at_value = 4; */
        if (message.doAtValue)
            APLValue.internalBinaryWrite(message.doAtValue, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool hide = 3; */
        if (message.hide !== false)
            writer.tag(3, WireType.Varint).bool(message.hide);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLPrepullAction
 */
export const APLPrepullAction = new APLPrepullAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLListItem$Type extends MessageType<APLListItem> {
    constructor() {
        super("proto.APLListItem", [
            { no: 1, name: "hide", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "action", kind: "message", T: () => APLAction }
        ]);
    }
    create(value?: PartialMessage<APLListItem>): APLListItem {
        const message = { hide: false, notes: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLListItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLListItem): APLListItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool hide */ 1:
                    message.hide = reader.bool();
                    break;
                case /* string notes */ 2:
                    message.notes = reader.string();
                    break;
                case /* proto.APLAction action */ 3:
                    message.action = APLAction.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLListItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool hide = 1; */
        if (message.hide !== false)
            writer.tag(1, WireType.Varint).bool(message.hide);
        /* string notes = 2; */
        if (message.notes !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.notes);
        /* proto.APLAction action = 3; */
        if (message.action)
            APLAction.internalBinaryWrite(message.action, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLListItem
 */
export const APLListItem = new APLListItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLAction$Type extends MessageType<APLAction> {
    constructor() {
        super("proto.APLAction", [
            { no: 1, name: "condition", kind: "message", T: () => APLValue },
            { no: 3, name: "cast_spell", kind: "message", oneof: "action", T: () => APLActionCastSpell },
            { no: 16, name: "channel_spell", kind: "message", oneof: "action", T: () => APLActionChannelSpell },
            { no: 8, name: "multidot", kind: "message", oneof: "action", T: () => APLActionMultidot },
            { no: 12, name: "multishield", kind: "message", oneof: "action", T: () => APLActionMultishield },
            { no: 7, name: "autocast_other_cooldowns", kind: "message", oneof: "action", T: () => APLActionAutocastOtherCooldowns },
            { no: 4, name: "wait", kind: "message", oneof: "action", T: () => APLActionWait },
            { no: 14, name: "wait_until", kind: "message", oneof: "action", T: () => APLActionWaitUntil },
            { no: 15, name: "schedule", kind: "message", oneof: "action", T: () => APLActionSchedule },
            { no: 2, name: "sequence", kind: "message", oneof: "action", T: () => APLActionSequence },
            { no: 5, name: "reset_sequence", kind: "message", oneof: "action", T: () => APLActionResetSequence },
            { no: 6, name: "strict_sequence", kind: "message", oneof: "action", T: () => APLActionStrictSequence },
            { no: 9, name: "change_target", kind: "message", oneof: "action", T: () => APLActionChangeTarget },
            { no: 13, name: "activate_aura", kind: "message", oneof: "action", T: () => APLActionActivateAura },
            { no: 10, name: "cancel_aura", kind: "message", oneof: "action", T: () => APLActionCancelAura },
            { no: 11, name: "trigger_icd", kind: "message", oneof: "action", T: () => APLActionTriggerICD },
            { no: 17, name: "item_swap", kind: "message", oneof: "action", T: () => APLActionItemSwap },
            { no: 18, name: "cat_optimal_rotation_action", kind: "message", oneof: "action", T: () => APLActionCatOptimalRotationAction },
            { no: 19, name: "custom_rotation", kind: "message", oneof: "action", T: () => APLActionCustomRotation }
        ]);
    }
    create(value?: PartialMessage<APLAction>): APLAction {
        const message = { action: { oneofKind: undefined } };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLAction): APLAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValue condition */ 1:
                    message.condition = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.condition);
                    break;
                case /* proto.APLActionCastSpell cast_spell */ 3:
                    message.action = {
                        oneofKind: "castSpell",
                        castSpell: APLActionCastSpell.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).castSpell)
                    };
                    break;
                case /* proto.APLActionChannelSpell channel_spell */ 16:
                    message.action = {
                        oneofKind: "channelSpell",
                        channelSpell: APLActionChannelSpell.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).channelSpell)
                    };
                    break;
                case /* proto.APLActionMultidot multidot */ 8:
                    message.action = {
                        oneofKind: "multidot",
                        multidot: APLActionMultidot.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).multidot)
                    };
                    break;
                case /* proto.APLActionMultishield multishield */ 12:
                    message.action = {
                        oneofKind: "multishield",
                        multishield: APLActionMultishield.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).multishield)
                    };
                    break;
                case /* proto.APLActionAutocastOtherCooldowns autocast_other_cooldowns */ 7:
                    message.action = {
                        oneofKind: "autocastOtherCooldowns",
                        autocastOtherCooldowns: APLActionAutocastOtherCooldowns.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).autocastOtherCooldowns)
                    };
                    break;
                case /* proto.APLActionWait wait */ 4:
                    message.action = {
                        oneofKind: "wait",
                        wait: APLActionWait.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).wait)
                    };
                    break;
                case /* proto.APLActionWaitUntil wait_until */ 14:
                    message.action = {
                        oneofKind: "waitUntil",
                        waitUntil: APLActionWaitUntil.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).waitUntil)
                    };
                    break;
                case /* proto.APLActionSchedule schedule */ 15:
                    message.action = {
                        oneofKind: "schedule",
                        schedule: APLActionSchedule.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).schedule)
                    };
                    break;
                case /* proto.APLActionSequence sequence */ 2:
                    message.action = {
                        oneofKind: "sequence",
                        sequence: APLActionSequence.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).sequence)
                    };
                    break;
                case /* proto.APLActionResetSequence reset_sequence */ 5:
                    message.action = {
                        oneofKind: "resetSequence",
                        resetSequence: APLActionResetSequence.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).resetSequence)
                    };
                    break;
                case /* proto.APLActionStrictSequence strict_sequence */ 6:
                    message.action = {
                        oneofKind: "strictSequence",
                        strictSequence: APLActionStrictSequence.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).strictSequence)
                    };
                    break;
                case /* proto.APLActionChangeTarget change_target */ 9:
                    message.action = {
                        oneofKind: "changeTarget",
                        changeTarget: APLActionChangeTarget.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).changeTarget)
                    };
                    break;
                case /* proto.APLActionActivateAura activate_aura */ 13:
                    message.action = {
                        oneofKind: "activateAura",
                        activateAura: APLActionActivateAura.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).activateAura)
                    };
                    break;
                case /* proto.APLActionCancelAura cancel_aura */ 10:
                    message.action = {
                        oneofKind: "cancelAura",
                        cancelAura: APLActionCancelAura.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).cancelAura)
                    };
                    break;
                case /* proto.APLActionTriggerICD trigger_icd */ 11:
                    message.action = {
                        oneofKind: "triggerIcd",
                        triggerIcd: APLActionTriggerICD.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).triggerIcd)
                    };
                    break;
                case /* proto.APLActionItemSwap item_swap */ 17:
                    message.action = {
                        oneofKind: "itemSwap",
                        itemSwap: APLActionItemSwap.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).itemSwap)
                    };
                    break;
                case /* proto.APLActionCatOptimalRotationAction cat_optimal_rotation_action */ 18:
                    message.action = {
                        oneofKind: "catOptimalRotationAction",
                        catOptimalRotationAction: APLActionCatOptimalRotationAction.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).catOptimalRotationAction)
                    };
                    break;
                case /* proto.APLActionCustomRotation custom_rotation */ 19:
                    message.action = {
                        oneofKind: "customRotation",
                        customRotation: APLActionCustomRotation.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).customRotation)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValue condition = 1; */
        if (message.condition)
            APLValue.internalBinaryWrite(message.condition, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionCastSpell cast_spell = 3; */
        if (message.action.oneofKind === "castSpell")
            APLActionCastSpell.internalBinaryWrite(message.action.castSpell, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionChannelSpell channel_spell = 16; */
        if (message.action.oneofKind === "channelSpell")
            APLActionChannelSpell.internalBinaryWrite(message.action.channelSpell, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionMultidot multidot = 8; */
        if (message.action.oneofKind === "multidot")
            APLActionMultidot.internalBinaryWrite(message.action.multidot, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionMultishield multishield = 12; */
        if (message.action.oneofKind === "multishield")
            APLActionMultishield.internalBinaryWrite(message.action.multishield, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionAutocastOtherCooldowns autocast_other_cooldowns = 7; */
        if (message.action.oneofKind === "autocastOtherCooldowns")
            APLActionAutocastOtherCooldowns.internalBinaryWrite(message.action.autocastOtherCooldowns, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionWait wait = 4; */
        if (message.action.oneofKind === "wait")
            APLActionWait.internalBinaryWrite(message.action.wait, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionWaitUntil wait_until = 14; */
        if (message.action.oneofKind === "waitUntil")
            APLActionWaitUntil.internalBinaryWrite(message.action.waitUntil, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionSchedule schedule = 15; */
        if (message.action.oneofKind === "schedule")
            APLActionSchedule.internalBinaryWrite(message.action.schedule, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionSequence sequence = 2; */
        if (message.action.oneofKind === "sequence")
            APLActionSequence.internalBinaryWrite(message.action.sequence, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionResetSequence reset_sequence = 5; */
        if (message.action.oneofKind === "resetSequence")
            APLActionResetSequence.internalBinaryWrite(message.action.resetSequence, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionStrictSequence strict_sequence = 6; */
        if (message.action.oneofKind === "strictSequence")
            APLActionStrictSequence.internalBinaryWrite(message.action.strictSequence, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionChangeTarget change_target = 9; */
        if (message.action.oneofKind === "changeTarget")
            APLActionChangeTarget.internalBinaryWrite(message.action.changeTarget, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionActivateAura activate_aura = 13; */
        if (message.action.oneofKind === "activateAura")
            APLActionActivateAura.internalBinaryWrite(message.action.activateAura, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionCancelAura cancel_aura = 10; */
        if (message.action.oneofKind === "cancelAura")
            APLActionCancelAura.internalBinaryWrite(message.action.cancelAura, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionTriggerICD trigger_icd = 11; */
        if (message.action.oneofKind === "triggerIcd")
            APLActionTriggerICD.internalBinaryWrite(message.action.triggerIcd, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionItemSwap item_swap = 17; */
        if (message.action.oneofKind === "itemSwap")
            APLActionItemSwap.internalBinaryWrite(message.action.itemSwap, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionCatOptimalRotationAction cat_optimal_rotation_action = 18; */
        if (message.action.oneofKind === "catOptimalRotationAction")
            APLActionCatOptimalRotationAction.internalBinaryWrite(message.action.catOptimalRotationAction, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLActionCustomRotation custom_rotation = 19; */
        if (message.action.oneofKind === "customRotation")
            APLActionCustomRotation.internalBinaryWrite(message.action.customRotation, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLAction
 */
export const APLAction = new APLAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValue$Type extends MessageType<APLValue> {
    constructor() {
        super("proto.APLValue", [
            { no: 1, name: "const", kind: "message", oneof: "value", T: () => APLValueConst },
            { no: 2, name: "and", kind: "message", oneof: "value", T: () => APLValueAnd },
            { no: 3, name: "or", kind: "message", oneof: "value", T: () => APLValueOr },
            { no: 4, name: "not", kind: "message", oneof: "value", T: () => APLValueNot },
            { no: 5, name: "cmp", kind: "message", oneof: "value", T: () => APLValueCompare },
            { no: 38, name: "math", kind: "message", oneof: "value", T: () => APLValueMath },
            { no: 47, name: "max", kind: "message", oneof: "value", T: () => APLValueMax },
            { no: 48, name: "min", kind: "message", oneof: "value", T: () => APLValueMin },
            { no: 7, name: "current_time", kind: "message", oneof: "value", T: () => APLValueCurrentTime },
            { no: 8, name: "current_time_percent", kind: "message", oneof: "value", T: () => APLValueCurrentTimePercent },
            { no: 9, name: "remaining_time", kind: "message", oneof: "value", T: () => APLValueRemainingTime },
            { no: 10, name: "remaining_time_percent", kind: "message", oneof: "value", T: () => APLValueRemainingTimePercent },
            { no: 41, name: "is_execute_phase", kind: "message", oneof: "value", T: () => APLValueIsExecutePhase },
            { no: 28, name: "number_targets", kind: "message", oneof: "value", T: () => APLValueNumberTargets },
            { no: 64, name: "boss_spell_time_to_ready", kind: "message", oneof: "value", T: () => APLValueBossSpellTimeToReady },
            { no: 65, name: "boss_spell_is_casting", kind: "message", oneof: "value", T: () => APLValueBossSpellIsCasting },
            { no: 26, name: "current_health", kind: "message", oneof: "value", T: () => APLValueCurrentHealth },
            { no: 27, name: "current_health_percent", kind: "message", oneof: "value", T: () => APLValueCurrentHealthPercent },
            { no: 11, name: "current_mana", kind: "message", oneof: "value", T: () => APLValueCurrentMana },
            { no: 12, name: "current_mana_percent", kind: "message", oneof: "value", T: () => APLValueCurrentManaPercent },
            { no: 14, name: "current_rage", kind: "message", oneof: "value", T: () => APLValueCurrentRage },
            { no: 15, name: "current_energy", kind: "message", oneof: "value", T: () => APLValueCurrentEnergy },
            { no: 16, name: "current_combo_points", kind: "message", oneof: "value", T: () => APLValueCurrentComboPoints },
            { no: 25, name: "current_runic_power", kind: "message", oneof: "value", T: () => APLValueCurrentRunicPower },
            { no: 29, name: "current_rune_count", kind: "message", oneof: "value", T: () => APLValueCurrentRuneCount },
            { no: 34, name: "current_non_death_rune_count", kind: "message", oneof: "value", T: () => APLValueCurrentNonDeathRuneCount },
            { no: 30, name: "current_rune_death", kind: "message", oneof: "value", T: () => APLValueCurrentRuneDeath },
            { no: 31, name: "current_rune_active", kind: "message", oneof: "value", T: () => APLValueCurrentRuneActive },
            { no: 32, name: "rune_cooldown", kind: "message", oneof: "value", T: () => APLValueRuneCooldown },
            { no: 33, name: "next_rune_cooldown", kind: "message", oneof: "value", T: () => APLValueNextRuneCooldown },
            { no: 53, name: "rune_slot_cooldown", kind: "message", oneof: "value", T: () => APLValueRuneSlotCooldown },
            { no: 54, name: "rune_grace", kind: "message", oneof: "value", T: () => APLValueRuneGrace },
            { no: 55, name: "rune_slot_grace", kind: "message", oneof: "value", T: () => APLValueRuneSlotGrace },
            { no: 17, name: "gcd_is_ready", kind: "message", oneof: "value", T: () => APLValueGCDIsReady },
            { no: 18, name: "gcd_time_to_ready", kind: "message", oneof: "value", T: () => APLValueGCDTimeToReady },
            { no: 40, name: "auto_time_to_next", kind: "message", oneof: "value", T: () => APLValueAutoTimeToNext },
            { no: 19, name: "spell_can_cast", kind: "message", oneof: "value", T: () => APLValueSpellCanCast },
            { no: 20, name: "spell_is_ready", kind: "message", oneof: "value", T: () => APLValueSpellIsReady },
            { no: 21, name: "spell_time_to_ready", kind: "message", oneof: "value", T: () => APLValueSpellTimeToReady },
            { no: 35, name: "spell_cast_time", kind: "message", oneof: "value", T: () => APLValueSpellCastTime },
            { no: 37, name: "spell_travel_time", kind: "message", oneof: "value", T: () => APLValueSpellTravelTime },
            { no: 42, name: "spell_cpm", kind: "message", oneof: "value", T: () => APLValueSpellCPM },
            { no: 56, name: "spell_is_channeling", kind: "message", oneof: "value", T: () => APLValueSpellIsChanneling },
            { no: 57, name: "spell_channeled_ticks", kind: "message", oneof: "value", T: () => APLValueSpellChanneledTicks },
            { no: 62, name: "spell_current_cost", kind: "message", oneof: "value", T: () => APLValueSpellCurrentCost },
            { no: 22, name: "aura_is_active", kind: "message", oneof: "value", T: () => APLValueAuraIsActive },
            { no: 50, name: "aura_is_active_with_reaction_time", kind: "message", oneof: "value", T: () => APLValueAuraIsActiveWithReactionTime },
            { no: 23, name: "aura_remaining_time", kind: "message", oneof: "value", T: () => APLValueAuraRemainingTime },
            { no: 24, name: "aura_num_stacks", kind: "message", oneof: "value", T: () => APLValueAuraNumStacks },
            { no: 39, name: "aura_internal_cooldown", kind: "message", oneof: "value", T: () => APLValueAuraInternalCooldown },
            { no: 51, name: "aura_icd_is_ready_with_reaction_time", kind: "message", oneof: "value", T: () => APLValueAuraICDIsReadyWithReactionTime },
            { no: 43, name: "aura_should_refresh", kind: "message", oneof: "value", T: () => APLValueAuraShouldRefresh },
            { no: 6, name: "dot_is_active", kind: "message", oneof: "value", T: () => APLValueDotIsActive },
            { no: 13, name: "dot_remaining_time", kind: "message", oneof: "value", T: () => APLValueDotRemainingTime },
            { no: 44, name: "sequence_is_complete", kind: "message", oneof: "value", T: () => APLValueSequenceIsComplete },
            { no: 45, name: "sequence_is_ready", kind: "message", oneof: "value", T: () => APLValueSequenceIsReady },
            { no: 46, name: "sequence_time_to_ready", kind: "message", oneof: "value", T: () => APLValueSequenceTimeToReady },
            { no: 58, name: "channel_clip_delay", kind: "message", oneof: "value", T: () => APLValueChannelClipDelay },
            { no: 63, name: "front_of_target", kind: "message", oneof: "value", T: () => APLValueFrontOfTarget },
            { no: 49, name: "totem_remaining_time", kind: "message", oneof: "value", T: () => APLValueTotemRemainingTime },
            { no: 52, name: "cat_excess_energy", kind: "message", oneof: "value", T: () => APLValueCatExcessEnergy },
            { no: 61, name: "cat_new_savage_roar_duration", kind: "message", oneof: "value", T: () => APLValueCatNewSavageRoarDuration },
            { no: 59, name: "warlock_should_recast_drain_soul", kind: "message", oneof: "value", T: () => APLValueWarlockShouldRecastDrainSoul },
            { no: 60, name: "warlock_should_refresh_corruption", kind: "message", oneof: "value", T: () => APLValueWarlockShouldRefreshCorruption }
        ]);
    }
    create(value?: PartialMessage<APLValue>): APLValue {
        const message = { value: { oneofKind: undefined } };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValue): APLValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueConst const */ 1:
                    message.value = {
                        oneofKind: "const",
                        const: APLValueConst.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).const)
                    };
                    break;
                case /* proto.APLValueAnd and */ 2:
                    message.value = {
                        oneofKind: "and",
                        and: APLValueAnd.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).and)
                    };
                    break;
                case /* proto.APLValueOr or */ 3:
                    message.value = {
                        oneofKind: "or",
                        or: APLValueOr.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).or)
                    };
                    break;
                case /* proto.APLValueNot not */ 4:
                    message.value = {
                        oneofKind: "not",
                        not: APLValueNot.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).not)
                    };
                    break;
                case /* proto.APLValueCompare cmp */ 5:
                    message.value = {
                        oneofKind: "cmp",
                        cmp: APLValueCompare.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).cmp)
                    };
                    break;
                case /* proto.APLValueMath math */ 38:
                    message.value = {
                        oneofKind: "math",
                        math: APLValueMath.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).math)
                    };
                    break;
                case /* proto.APLValueMax max */ 47:
                    message.value = {
                        oneofKind: "max",
                        max: APLValueMax.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).max)
                    };
                    break;
                case /* proto.APLValueMin min */ 48:
                    message.value = {
                        oneofKind: "min",
                        min: APLValueMin.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).min)
                    };
                    break;
                case /* proto.APLValueCurrentTime current_time */ 7:
                    message.value = {
                        oneofKind: "currentTime",
                        currentTime: APLValueCurrentTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentTime)
                    };
                    break;
                case /* proto.APLValueCurrentTimePercent current_time_percent */ 8:
                    message.value = {
                        oneofKind: "currentTimePercent",
                        currentTimePercent: APLValueCurrentTimePercent.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentTimePercent)
                    };
                    break;
                case /* proto.APLValueRemainingTime remaining_time */ 9:
                    message.value = {
                        oneofKind: "remainingTime",
                        remainingTime: APLValueRemainingTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).remainingTime)
                    };
                    break;
                case /* proto.APLValueRemainingTimePercent remaining_time_percent */ 10:
                    message.value = {
                        oneofKind: "remainingTimePercent",
                        remainingTimePercent: APLValueRemainingTimePercent.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).remainingTimePercent)
                    };
                    break;
                case /* proto.APLValueIsExecutePhase is_execute_phase */ 41:
                    message.value = {
                        oneofKind: "isExecutePhase",
                        isExecutePhase: APLValueIsExecutePhase.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).isExecutePhase)
                    };
                    break;
                case /* proto.APLValueNumberTargets number_targets */ 28:
                    message.value = {
                        oneofKind: "numberTargets",
                        numberTargets: APLValueNumberTargets.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).numberTargets)
                    };
                    break;
                case /* proto.APLValueBossSpellTimeToReady boss_spell_time_to_ready */ 64:
                    message.value = {
                        oneofKind: "bossSpellTimeToReady",
                        bossSpellTimeToReady: APLValueBossSpellTimeToReady.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).bossSpellTimeToReady)
                    };
                    break;
                case /* proto.APLValueBossSpellIsCasting boss_spell_is_casting */ 65:
                    message.value = {
                        oneofKind: "bossSpellIsCasting",
                        bossSpellIsCasting: APLValueBossSpellIsCasting.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).bossSpellIsCasting)
                    };
                    break;
                case /* proto.APLValueCurrentHealth current_health */ 26:
                    message.value = {
                        oneofKind: "currentHealth",
                        currentHealth: APLValueCurrentHealth.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentHealth)
                    };
                    break;
                case /* proto.APLValueCurrentHealthPercent current_health_percent */ 27:
                    message.value = {
                        oneofKind: "currentHealthPercent",
                        currentHealthPercent: APLValueCurrentHealthPercent.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentHealthPercent)
                    };
                    break;
                case /* proto.APLValueCurrentMana current_mana */ 11:
                    message.value = {
                        oneofKind: "currentMana",
                        currentMana: APLValueCurrentMana.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentMana)
                    };
                    break;
                case /* proto.APLValueCurrentManaPercent current_mana_percent */ 12:
                    message.value = {
                        oneofKind: "currentManaPercent",
                        currentManaPercent: APLValueCurrentManaPercent.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentManaPercent)
                    };
                    break;
                case /* proto.APLValueCurrentRage current_rage */ 14:
                    message.value = {
                        oneofKind: "currentRage",
                        currentRage: APLValueCurrentRage.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentRage)
                    };
                    break;
                case /* proto.APLValueCurrentEnergy current_energy */ 15:
                    message.value = {
                        oneofKind: "currentEnergy",
                        currentEnergy: APLValueCurrentEnergy.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentEnergy)
                    };
                    break;
                case /* proto.APLValueCurrentComboPoints current_combo_points */ 16:
                    message.value = {
                        oneofKind: "currentComboPoints",
                        currentComboPoints: APLValueCurrentComboPoints.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentComboPoints)
                    };
                    break;
                case /* proto.APLValueCurrentRunicPower current_runic_power */ 25:
                    message.value = {
                        oneofKind: "currentRunicPower",
                        currentRunicPower: APLValueCurrentRunicPower.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentRunicPower)
                    };
                    break;
                case /* proto.APLValueCurrentRuneCount current_rune_count */ 29:
                    message.value = {
                        oneofKind: "currentRuneCount",
                        currentRuneCount: APLValueCurrentRuneCount.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentRuneCount)
                    };
                    break;
                case /* proto.APLValueCurrentNonDeathRuneCount current_non_death_rune_count */ 34:
                    message.value = {
                        oneofKind: "currentNonDeathRuneCount",
                        currentNonDeathRuneCount: APLValueCurrentNonDeathRuneCount.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentNonDeathRuneCount)
                    };
                    break;
                case /* proto.APLValueCurrentRuneDeath current_rune_death */ 30:
                    message.value = {
                        oneofKind: "currentRuneDeath",
                        currentRuneDeath: APLValueCurrentRuneDeath.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentRuneDeath)
                    };
                    break;
                case /* proto.APLValueCurrentRuneActive current_rune_active */ 31:
                    message.value = {
                        oneofKind: "currentRuneActive",
                        currentRuneActive: APLValueCurrentRuneActive.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).currentRuneActive)
                    };
                    break;
                case /* proto.APLValueRuneCooldown rune_cooldown */ 32:
                    message.value = {
                        oneofKind: "runeCooldown",
                        runeCooldown: APLValueRuneCooldown.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).runeCooldown)
                    };
                    break;
                case /* proto.APLValueNextRuneCooldown next_rune_cooldown */ 33:
                    message.value = {
                        oneofKind: "nextRuneCooldown",
                        nextRuneCooldown: APLValueNextRuneCooldown.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).nextRuneCooldown)
                    };
                    break;
                case /* proto.APLValueRuneSlotCooldown rune_slot_cooldown */ 53:
                    message.value = {
                        oneofKind: "runeSlotCooldown",
                        runeSlotCooldown: APLValueRuneSlotCooldown.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).runeSlotCooldown)
                    };
                    break;
                case /* proto.APLValueRuneGrace rune_grace */ 54:
                    message.value = {
                        oneofKind: "runeGrace",
                        runeGrace: APLValueRuneGrace.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).runeGrace)
                    };
                    break;
                case /* proto.APLValueRuneSlotGrace rune_slot_grace */ 55:
                    message.value = {
                        oneofKind: "runeSlotGrace",
                        runeSlotGrace: APLValueRuneSlotGrace.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).runeSlotGrace)
                    };
                    break;
                case /* proto.APLValueGCDIsReady gcd_is_ready */ 17:
                    message.value = {
                        oneofKind: "gcdIsReady",
                        gcdIsReady: APLValueGCDIsReady.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).gcdIsReady)
                    };
                    break;
                case /* proto.APLValueGCDTimeToReady gcd_time_to_ready */ 18:
                    message.value = {
                        oneofKind: "gcdTimeToReady",
                        gcdTimeToReady: APLValueGCDTimeToReady.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).gcdTimeToReady)
                    };
                    break;
                case /* proto.APLValueAutoTimeToNext auto_time_to_next */ 40:
                    message.value = {
                        oneofKind: "autoTimeToNext",
                        autoTimeToNext: APLValueAutoTimeToNext.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).autoTimeToNext)
                    };
                    break;
                case /* proto.APLValueSpellCanCast spell_can_cast */ 19:
                    message.value = {
                        oneofKind: "spellCanCast",
                        spellCanCast: APLValueSpellCanCast.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellCanCast)
                    };
                    break;
                case /* proto.APLValueSpellIsReady spell_is_ready */ 20:
                    message.value = {
                        oneofKind: "spellIsReady",
                        spellIsReady: APLValueSpellIsReady.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellIsReady)
                    };
                    break;
                case /* proto.APLValueSpellTimeToReady spell_time_to_ready */ 21:
                    message.value = {
                        oneofKind: "spellTimeToReady",
                        spellTimeToReady: APLValueSpellTimeToReady.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellTimeToReady)
                    };
                    break;
                case /* proto.APLValueSpellCastTime spell_cast_time */ 35:
                    message.value = {
                        oneofKind: "spellCastTime",
                        spellCastTime: APLValueSpellCastTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellCastTime)
                    };
                    break;
                case /* proto.APLValueSpellTravelTime spell_travel_time */ 37:
                    message.value = {
                        oneofKind: "spellTravelTime",
                        spellTravelTime: APLValueSpellTravelTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellTravelTime)
                    };
                    break;
                case /* proto.APLValueSpellCPM spell_cpm */ 42:
                    message.value = {
                        oneofKind: "spellCpm",
                        spellCpm: APLValueSpellCPM.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellCpm)
                    };
                    break;
                case /* proto.APLValueSpellIsChanneling spell_is_channeling */ 56:
                    message.value = {
                        oneofKind: "spellIsChanneling",
                        spellIsChanneling: APLValueSpellIsChanneling.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellIsChanneling)
                    };
                    break;
                case /* proto.APLValueSpellChanneledTicks spell_channeled_ticks */ 57:
                    message.value = {
                        oneofKind: "spellChanneledTicks",
                        spellChanneledTicks: APLValueSpellChanneledTicks.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellChanneledTicks)
                    };
                    break;
                case /* proto.APLValueSpellCurrentCost spell_current_cost */ 62:
                    message.value = {
                        oneofKind: "spellCurrentCost",
                        spellCurrentCost: APLValueSpellCurrentCost.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).spellCurrentCost)
                    };
                    break;
                case /* proto.APLValueAuraIsActive aura_is_active */ 22:
                    message.value = {
                        oneofKind: "auraIsActive",
                        auraIsActive: APLValueAuraIsActive.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).auraIsActive)
                    };
                    break;
                case /* proto.APLValueAuraIsActiveWithReactionTime aura_is_active_with_reaction_time */ 50:
                    message.value = {
                        oneofKind: "auraIsActiveWithReactionTime",
                        auraIsActiveWithReactionTime: APLValueAuraIsActiveWithReactionTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).auraIsActiveWithReactionTime)
                    };
                    break;
                case /* proto.APLValueAuraRemainingTime aura_remaining_time */ 23:
                    message.value = {
                        oneofKind: "auraRemainingTime",
                        auraRemainingTime: APLValueAuraRemainingTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).auraRemainingTime)
                    };
                    break;
                case /* proto.APLValueAuraNumStacks aura_num_stacks */ 24:
                    message.value = {
                        oneofKind: "auraNumStacks",
                        auraNumStacks: APLValueAuraNumStacks.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).auraNumStacks)
                    };
                    break;
                case /* proto.APLValueAuraInternalCooldown aura_internal_cooldown */ 39:
                    message.value = {
                        oneofKind: "auraInternalCooldown",
                        auraInternalCooldown: APLValueAuraInternalCooldown.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).auraInternalCooldown)
                    };
                    break;
                case /* proto.APLValueAuraICDIsReadyWithReactionTime aura_icd_is_ready_with_reaction_time */ 51:
                    message.value = {
                        oneofKind: "auraIcdIsReadyWithReactionTime",
                        auraIcdIsReadyWithReactionTime: APLValueAuraICDIsReadyWithReactionTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).auraIcdIsReadyWithReactionTime)
                    };
                    break;
                case /* proto.APLValueAuraShouldRefresh aura_should_refresh */ 43:
                    message.value = {
                        oneofKind: "auraShouldRefresh",
                        auraShouldRefresh: APLValueAuraShouldRefresh.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).auraShouldRefresh)
                    };
                    break;
                case /* proto.APLValueDotIsActive dot_is_active */ 6:
                    message.value = {
                        oneofKind: "dotIsActive",
                        dotIsActive: APLValueDotIsActive.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).dotIsActive)
                    };
                    break;
                case /* proto.APLValueDotRemainingTime dot_remaining_time */ 13:
                    message.value = {
                        oneofKind: "dotRemainingTime",
                        dotRemainingTime: APLValueDotRemainingTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).dotRemainingTime)
                    };
                    break;
                case /* proto.APLValueSequenceIsComplete sequence_is_complete */ 44:
                    message.value = {
                        oneofKind: "sequenceIsComplete",
                        sequenceIsComplete: APLValueSequenceIsComplete.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).sequenceIsComplete)
                    };
                    break;
                case /* proto.APLValueSequenceIsReady sequence_is_ready */ 45:
                    message.value = {
                        oneofKind: "sequenceIsReady",
                        sequenceIsReady: APLValueSequenceIsReady.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).sequenceIsReady)
                    };
                    break;
                case /* proto.APLValueSequenceTimeToReady sequence_time_to_ready */ 46:
                    message.value = {
                        oneofKind: "sequenceTimeToReady",
                        sequenceTimeToReady: APLValueSequenceTimeToReady.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).sequenceTimeToReady)
                    };
                    break;
                case /* proto.APLValueChannelClipDelay channel_clip_delay */ 58:
                    message.value = {
                        oneofKind: "channelClipDelay",
                        channelClipDelay: APLValueChannelClipDelay.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).channelClipDelay)
                    };
                    break;
                case /* proto.APLValueFrontOfTarget front_of_target */ 63:
                    message.value = {
                        oneofKind: "frontOfTarget",
                        frontOfTarget: APLValueFrontOfTarget.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).frontOfTarget)
                    };
                    break;
                case /* proto.APLValueTotemRemainingTime totem_remaining_time */ 49:
                    message.value = {
                        oneofKind: "totemRemainingTime",
                        totemRemainingTime: APLValueTotemRemainingTime.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).totemRemainingTime)
                    };
                    break;
                case /* proto.APLValueCatExcessEnergy cat_excess_energy */ 52:
                    message.value = {
                        oneofKind: "catExcessEnergy",
                        catExcessEnergy: APLValueCatExcessEnergy.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).catExcessEnergy)
                    };
                    break;
                case /* proto.APLValueCatNewSavageRoarDuration cat_new_savage_roar_duration */ 61:
                    message.value = {
                        oneofKind: "catNewSavageRoarDuration",
                        catNewSavageRoarDuration: APLValueCatNewSavageRoarDuration.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).catNewSavageRoarDuration)
                    };
                    break;
                case /* proto.APLValueWarlockShouldRecastDrainSoul warlock_should_recast_drain_soul */ 59:
                    message.value = {
                        oneofKind: "warlockShouldRecastDrainSoul",
                        warlockShouldRecastDrainSoul: APLValueWarlockShouldRecastDrainSoul.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).warlockShouldRecastDrainSoul)
                    };
                    break;
                case /* proto.APLValueWarlockShouldRefreshCorruption warlock_should_refresh_corruption */ 60:
                    message.value = {
                        oneofKind: "warlockShouldRefreshCorruption",
                        warlockShouldRefreshCorruption: APLValueWarlockShouldRefreshCorruption.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).warlockShouldRefreshCorruption)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueConst const = 1; */
        if (message.value.oneofKind === "const")
            APLValueConst.internalBinaryWrite(message.value.const, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAnd and = 2; */
        if (message.value.oneofKind === "and")
            APLValueAnd.internalBinaryWrite(message.value.and, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueOr or = 3; */
        if (message.value.oneofKind === "or")
            APLValueOr.internalBinaryWrite(message.value.or, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueNot not = 4; */
        if (message.value.oneofKind === "not")
            APLValueNot.internalBinaryWrite(message.value.not, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCompare cmp = 5; */
        if (message.value.oneofKind === "cmp")
            APLValueCompare.internalBinaryWrite(message.value.cmp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueMath math = 38; */
        if (message.value.oneofKind === "math")
            APLValueMath.internalBinaryWrite(message.value.math, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueMax max = 47; */
        if (message.value.oneofKind === "max")
            APLValueMax.internalBinaryWrite(message.value.max, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueMin min = 48; */
        if (message.value.oneofKind === "min")
            APLValueMin.internalBinaryWrite(message.value.min, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentTime current_time = 7; */
        if (message.value.oneofKind === "currentTime")
            APLValueCurrentTime.internalBinaryWrite(message.value.currentTime, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentTimePercent current_time_percent = 8; */
        if (message.value.oneofKind === "currentTimePercent")
            APLValueCurrentTimePercent.internalBinaryWrite(message.value.currentTimePercent, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueRemainingTime remaining_time = 9; */
        if (message.value.oneofKind === "remainingTime")
            APLValueRemainingTime.internalBinaryWrite(message.value.remainingTime, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueRemainingTimePercent remaining_time_percent = 10; */
        if (message.value.oneofKind === "remainingTimePercent")
            APLValueRemainingTimePercent.internalBinaryWrite(message.value.remainingTimePercent, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueIsExecutePhase is_execute_phase = 41; */
        if (message.value.oneofKind === "isExecutePhase")
            APLValueIsExecutePhase.internalBinaryWrite(message.value.isExecutePhase, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueNumberTargets number_targets = 28; */
        if (message.value.oneofKind === "numberTargets")
            APLValueNumberTargets.internalBinaryWrite(message.value.numberTargets, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueBossSpellTimeToReady boss_spell_time_to_ready = 64; */
        if (message.value.oneofKind === "bossSpellTimeToReady")
            APLValueBossSpellTimeToReady.internalBinaryWrite(message.value.bossSpellTimeToReady, writer.tag(64, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueBossSpellIsCasting boss_spell_is_casting = 65; */
        if (message.value.oneofKind === "bossSpellIsCasting")
            APLValueBossSpellIsCasting.internalBinaryWrite(message.value.bossSpellIsCasting, writer.tag(65, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentHealth current_health = 26; */
        if (message.value.oneofKind === "currentHealth")
            APLValueCurrentHealth.internalBinaryWrite(message.value.currentHealth, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentHealthPercent current_health_percent = 27; */
        if (message.value.oneofKind === "currentHealthPercent")
            APLValueCurrentHealthPercent.internalBinaryWrite(message.value.currentHealthPercent, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentMana current_mana = 11; */
        if (message.value.oneofKind === "currentMana")
            APLValueCurrentMana.internalBinaryWrite(message.value.currentMana, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentManaPercent current_mana_percent = 12; */
        if (message.value.oneofKind === "currentManaPercent")
            APLValueCurrentManaPercent.internalBinaryWrite(message.value.currentManaPercent, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentRage current_rage = 14; */
        if (message.value.oneofKind === "currentRage")
            APLValueCurrentRage.internalBinaryWrite(message.value.currentRage, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentEnergy current_energy = 15; */
        if (message.value.oneofKind === "currentEnergy")
            APLValueCurrentEnergy.internalBinaryWrite(message.value.currentEnergy, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentComboPoints current_combo_points = 16; */
        if (message.value.oneofKind === "currentComboPoints")
            APLValueCurrentComboPoints.internalBinaryWrite(message.value.currentComboPoints, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentRunicPower current_runic_power = 25; */
        if (message.value.oneofKind === "currentRunicPower")
            APLValueCurrentRunicPower.internalBinaryWrite(message.value.currentRunicPower, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentRuneCount current_rune_count = 29; */
        if (message.value.oneofKind === "currentRuneCount")
            APLValueCurrentRuneCount.internalBinaryWrite(message.value.currentRuneCount, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentNonDeathRuneCount current_non_death_rune_count = 34; */
        if (message.value.oneofKind === "currentNonDeathRuneCount")
            APLValueCurrentNonDeathRuneCount.internalBinaryWrite(message.value.currentNonDeathRuneCount, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentRuneDeath current_rune_death = 30; */
        if (message.value.oneofKind === "currentRuneDeath")
            APLValueCurrentRuneDeath.internalBinaryWrite(message.value.currentRuneDeath, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCurrentRuneActive current_rune_active = 31; */
        if (message.value.oneofKind === "currentRuneActive")
            APLValueCurrentRuneActive.internalBinaryWrite(message.value.currentRuneActive, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueRuneCooldown rune_cooldown = 32; */
        if (message.value.oneofKind === "runeCooldown")
            APLValueRuneCooldown.internalBinaryWrite(message.value.runeCooldown, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueNextRuneCooldown next_rune_cooldown = 33; */
        if (message.value.oneofKind === "nextRuneCooldown")
            APLValueNextRuneCooldown.internalBinaryWrite(message.value.nextRuneCooldown, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueRuneSlotCooldown rune_slot_cooldown = 53; */
        if (message.value.oneofKind === "runeSlotCooldown")
            APLValueRuneSlotCooldown.internalBinaryWrite(message.value.runeSlotCooldown, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueRuneGrace rune_grace = 54; */
        if (message.value.oneofKind === "runeGrace")
            APLValueRuneGrace.internalBinaryWrite(message.value.runeGrace, writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueRuneSlotGrace rune_slot_grace = 55; */
        if (message.value.oneofKind === "runeSlotGrace")
            APLValueRuneSlotGrace.internalBinaryWrite(message.value.runeSlotGrace, writer.tag(55, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueGCDIsReady gcd_is_ready = 17; */
        if (message.value.oneofKind === "gcdIsReady")
            APLValueGCDIsReady.internalBinaryWrite(message.value.gcdIsReady, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueGCDTimeToReady gcd_time_to_ready = 18; */
        if (message.value.oneofKind === "gcdTimeToReady")
            APLValueGCDTimeToReady.internalBinaryWrite(message.value.gcdTimeToReady, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAutoTimeToNext auto_time_to_next = 40; */
        if (message.value.oneofKind === "autoTimeToNext")
            APLValueAutoTimeToNext.internalBinaryWrite(message.value.autoTimeToNext, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellCanCast spell_can_cast = 19; */
        if (message.value.oneofKind === "spellCanCast")
            APLValueSpellCanCast.internalBinaryWrite(message.value.spellCanCast, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellIsReady spell_is_ready = 20; */
        if (message.value.oneofKind === "spellIsReady")
            APLValueSpellIsReady.internalBinaryWrite(message.value.spellIsReady, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellTimeToReady spell_time_to_ready = 21; */
        if (message.value.oneofKind === "spellTimeToReady")
            APLValueSpellTimeToReady.internalBinaryWrite(message.value.spellTimeToReady, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellCastTime spell_cast_time = 35; */
        if (message.value.oneofKind === "spellCastTime")
            APLValueSpellCastTime.internalBinaryWrite(message.value.spellCastTime, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellTravelTime spell_travel_time = 37; */
        if (message.value.oneofKind === "spellTravelTime")
            APLValueSpellTravelTime.internalBinaryWrite(message.value.spellTravelTime, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellCPM spell_cpm = 42; */
        if (message.value.oneofKind === "spellCpm")
            APLValueSpellCPM.internalBinaryWrite(message.value.spellCpm, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellIsChanneling spell_is_channeling = 56; */
        if (message.value.oneofKind === "spellIsChanneling")
            APLValueSpellIsChanneling.internalBinaryWrite(message.value.spellIsChanneling, writer.tag(56, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellChanneledTicks spell_channeled_ticks = 57; */
        if (message.value.oneofKind === "spellChanneledTicks")
            APLValueSpellChanneledTicks.internalBinaryWrite(message.value.spellChanneledTicks, writer.tag(57, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSpellCurrentCost spell_current_cost = 62; */
        if (message.value.oneofKind === "spellCurrentCost")
            APLValueSpellCurrentCost.internalBinaryWrite(message.value.spellCurrentCost, writer.tag(62, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAuraIsActive aura_is_active = 22; */
        if (message.value.oneofKind === "auraIsActive")
            APLValueAuraIsActive.internalBinaryWrite(message.value.auraIsActive, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAuraIsActiveWithReactionTime aura_is_active_with_reaction_time = 50; */
        if (message.value.oneofKind === "auraIsActiveWithReactionTime")
            APLValueAuraIsActiveWithReactionTime.internalBinaryWrite(message.value.auraIsActiveWithReactionTime, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAuraRemainingTime aura_remaining_time = 23; */
        if (message.value.oneofKind === "auraRemainingTime")
            APLValueAuraRemainingTime.internalBinaryWrite(message.value.auraRemainingTime, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAuraNumStacks aura_num_stacks = 24; */
        if (message.value.oneofKind === "auraNumStacks")
            APLValueAuraNumStacks.internalBinaryWrite(message.value.auraNumStacks, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAuraInternalCooldown aura_internal_cooldown = 39; */
        if (message.value.oneofKind === "auraInternalCooldown")
            APLValueAuraInternalCooldown.internalBinaryWrite(message.value.auraInternalCooldown, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAuraICDIsReadyWithReactionTime aura_icd_is_ready_with_reaction_time = 51; */
        if (message.value.oneofKind === "auraIcdIsReadyWithReactionTime")
            APLValueAuraICDIsReadyWithReactionTime.internalBinaryWrite(message.value.auraIcdIsReadyWithReactionTime, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueAuraShouldRefresh aura_should_refresh = 43; */
        if (message.value.oneofKind === "auraShouldRefresh")
            APLValueAuraShouldRefresh.internalBinaryWrite(message.value.auraShouldRefresh, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueDotIsActive dot_is_active = 6; */
        if (message.value.oneofKind === "dotIsActive")
            APLValueDotIsActive.internalBinaryWrite(message.value.dotIsActive, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueDotRemainingTime dot_remaining_time = 13; */
        if (message.value.oneofKind === "dotRemainingTime")
            APLValueDotRemainingTime.internalBinaryWrite(message.value.dotRemainingTime, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSequenceIsComplete sequence_is_complete = 44; */
        if (message.value.oneofKind === "sequenceIsComplete")
            APLValueSequenceIsComplete.internalBinaryWrite(message.value.sequenceIsComplete, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSequenceIsReady sequence_is_ready = 45; */
        if (message.value.oneofKind === "sequenceIsReady")
            APLValueSequenceIsReady.internalBinaryWrite(message.value.sequenceIsReady, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueSequenceTimeToReady sequence_time_to_ready = 46; */
        if (message.value.oneofKind === "sequenceTimeToReady")
            APLValueSequenceTimeToReady.internalBinaryWrite(message.value.sequenceTimeToReady, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueChannelClipDelay channel_clip_delay = 58; */
        if (message.value.oneofKind === "channelClipDelay")
            APLValueChannelClipDelay.internalBinaryWrite(message.value.channelClipDelay, writer.tag(58, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueFrontOfTarget front_of_target = 63; */
        if (message.value.oneofKind === "frontOfTarget")
            APLValueFrontOfTarget.internalBinaryWrite(message.value.frontOfTarget, writer.tag(63, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueTotemRemainingTime totem_remaining_time = 49; */
        if (message.value.oneofKind === "totemRemainingTime")
            APLValueTotemRemainingTime.internalBinaryWrite(message.value.totemRemainingTime, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCatExcessEnergy cat_excess_energy = 52; */
        if (message.value.oneofKind === "catExcessEnergy")
            APLValueCatExcessEnergy.internalBinaryWrite(message.value.catExcessEnergy, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueCatNewSavageRoarDuration cat_new_savage_roar_duration = 61; */
        if (message.value.oneofKind === "catNewSavageRoarDuration")
            APLValueCatNewSavageRoarDuration.internalBinaryWrite(message.value.catNewSavageRoarDuration, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueWarlockShouldRecastDrainSoul warlock_should_recast_drain_soul = 59; */
        if (message.value.oneofKind === "warlockShouldRecastDrainSoul")
            APLValueWarlockShouldRecastDrainSoul.internalBinaryWrite(message.value.warlockShouldRecastDrainSoul, writer.tag(59, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValueWarlockShouldRefreshCorruption warlock_should_refresh_corruption = 60; */
        if (message.value.oneofKind === "warlockShouldRefreshCorruption")
            APLValueWarlockShouldRefreshCorruption.internalBinaryWrite(message.value.warlockShouldRefreshCorruption, writer.tag(60, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValue
 */
export const APLValue = new APLValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionCastSpell$Type extends MessageType<APLActionCastSpell> {
    constructor() {
        super("proto.APLActionCastSpell", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID },
            { no: 2, name: "target", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<APLActionCastSpell>): APLActionCastSpell {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionCastSpell>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionCastSpell): APLActionCastSpell {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                case /* proto.UnitReference target */ 2:
                    message.target = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionCastSpell, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitReference target = 2; */
        if (message.target)
            UnitReference.internalBinaryWrite(message.target, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionCastSpell
 */
export const APLActionCastSpell = new APLActionCastSpell$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionChannelSpell$Type extends MessageType<APLActionChannelSpell> {
    constructor() {
        super("proto.APLActionChannelSpell", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID },
            { no: 2, name: "target", kind: "message", T: () => UnitReference },
            { no: 3, name: "interrupt_if", kind: "message", T: () => APLValue },
            { no: 5, name: "allow_recast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<APLActionChannelSpell>): APLActionChannelSpell {
        const message = { allowRecast: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionChannelSpell>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionChannelSpell): APLActionChannelSpell {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                case /* proto.UnitReference target */ 2:
                    message.target = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                case /* proto.APLValue interrupt_if */ 3:
                    message.interruptIf = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.interruptIf);
                    break;
                case /* bool allow_recast */ 5:
                    message.allowRecast = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionChannelSpell, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitReference target = 2; */
        if (message.target)
            UnitReference.internalBinaryWrite(message.target, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValue interrupt_if = 3; */
        if (message.interruptIf)
            APLValue.internalBinaryWrite(message.interruptIf, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool allow_recast = 5; */
        if (message.allowRecast !== false)
            writer.tag(5, WireType.Varint).bool(message.allowRecast);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionChannelSpell
 */
export const APLActionChannelSpell = new APLActionChannelSpell$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionMultidot$Type extends MessageType<APLActionMultidot> {
    constructor() {
        super("proto.APLActionMultidot", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID },
            { no: 2, name: "max_dots", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "max_overlap", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLActionMultidot>): APLActionMultidot {
        const message = { maxDots: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionMultidot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionMultidot): APLActionMultidot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                case /* int32 max_dots */ 2:
                    message.maxDots = reader.int32();
                    break;
                case /* proto.APLValue max_overlap */ 3:
                    message.maxOverlap = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.maxOverlap);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionMultidot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 max_dots = 2; */
        if (message.maxDots !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxDots);
        /* proto.APLValue max_overlap = 3; */
        if (message.maxOverlap)
            APLValue.internalBinaryWrite(message.maxOverlap, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionMultidot
 */
export const APLActionMultidot = new APLActionMultidot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionMultishield$Type extends MessageType<APLActionMultishield> {
    constructor() {
        super("proto.APLActionMultishield", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID },
            { no: 2, name: "max_shields", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "max_overlap", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLActionMultishield>): APLActionMultishield {
        const message = { maxShields: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionMultishield>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionMultishield): APLActionMultishield {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                case /* int32 max_shields */ 2:
                    message.maxShields = reader.int32();
                    break;
                case /* proto.APLValue max_overlap */ 3:
                    message.maxOverlap = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.maxOverlap);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionMultishield, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 max_shields = 2; */
        if (message.maxShields !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxShields);
        /* proto.APLValue max_overlap = 3; */
        if (message.maxOverlap)
            APLValue.internalBinaryWrite(message.maxOverlap, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionMultishield
 */
export const APLActionMultishield = new APLActionMultishield$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionAutocastOtherCooldowns$Type extends MessageType<APLActionAutocastOtherCooldowns> {
    constructor() {
        super("proto.APLActionAutocastOtherCooldowns", []);
    }
    create(value?: PartialMessage<APLActionAutocastOtherCooldowns>): APLActionAutocastOtherCooldowns {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionAutocastOtherCooldowns>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionAutocastOtherCooldowns): APLActionAutocastOtherCooldowns {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLActionAutocastOtherCooldowns, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionAutocastOtherCooldowns
 */
export const APLActionAutocastOtherCooldowns = new APLActionAutocastOtherCooldowns$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionWait$Type extends MessageType<APLActionWait> {
    constructor() {
        super("proto.APLActionWait", [
            { no: 1, name: "duration", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLActionWait>): APLActionWait {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionWait>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionWait): APLActionWait {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValue duration */ 1:
                    message.duration = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.duration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionWait, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValue duration = 1; */
        if (message.duration)
            APLValue.internalBinaryWrite(message.duration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionWait
 */
export const APLActionWait = new APLActionWait$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionWaitUntil$Type extends MessageType<APLActionWaitUntil> {
    constructor() {
        super("proto.APLActionWaitUntil", [
            { no: 1, name: "condition", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLActionWaitUntil>): APLActionWaitUntil {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionWaitUntil>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionWaitUntil): APLActionWaitUntil {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValue condition */ 1:
                    message.condition = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.condition);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionWaitUntil, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValue condition = 1; */
        if (message.condition)
            APLValue.internalBinaryWrite(message.condition, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionWaitUntil
 */
export const APLActionWaitUntil = new APLActionWaitUntil$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionSchedule$Type extends MessageType<APLActionSchedule> {
    constructor() {
        super("proto.APLActionSchedule", [
            { no: 1, name: "schedule", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inner_action", kind: "message", T: () => APLAction }
        ]);
    }
    create(value?: PartialMessage<APLActionSchedule>): APLActionSchedule {
        const message = { schedule: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionSchedule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionSchedule): APLActionSchedule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string schedule */ 1:
                    message.schedule = reader.string();
                    break;
                case /* proto.APLAction inner_action */ 2:
                    message.innerAction = APLAction.internalBinaryRead(reader, reader.uint32(), options, message.innerAction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionSchedule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string schedule = 1; */
        if (message.schedule !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.schedule);
        /* proto.APLAction inner_action = 2; */
        if (message.innerAction)
            APLAction.internalBinaryWrite(message.innerAction, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionSchedule
 */
export const APLActionSchedule = new APLActionSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionSequence$Type extends MessageType<APLActionSequence> {
    constructor() {
        super("proto.APLActionSequence", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLAction }
        ]);
    }
    create(value?: PartialMessage<APLActionSequence>): APLActionSequence {
        const message = { name: "", actions: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionSequence>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionSequence): APLActionSequence {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* repeated proto.APLAction actions */ 2:
                    message.actions.push(APLAction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionSequence, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* repeated proto.APLAction actions = 2; */
        for (let i = 0; i < message.actions.length; i++)
            APLAction.internalBinaryWrite(message.actions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionSequence
 */
export const APLActionSequence = new APLActionSequence$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionResetSequence$Type extends MessageType<APLActionResetSequence> {
    constructor() {
        super("proto.APLActionResetSequence", [
            { no: 1, name: "sequence_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<APLActionResetSequence>): APLActionResetSequence {
        const message = { sequenceName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionResetSequence>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionResetSequence): APLActionResetSequence {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sequence_name */ 1:
                    message.sequenceName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionResetSequence, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sequence_name = 1; */
        if (message.sequenceName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sequenceName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionResetSequence
 */
export const APLActionResetSequence = new APLActionResetSequence$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionStrictSequence$Type extends MessageType<APLActionStrictSequence> {
    constructor() {
        super("proto.APLActionStrictSequence", [
            { no: 1, name: "actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLAction }
        ]);
    }
    create(value?: PartialMessage<APLActionStrictSequence>): APLActionStrictSequence {
        const message = { actions: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionStrictSequence>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionStrictSequence): APLActionStrictSequence {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.APLAction actions */ 1:
                    message.actions.push(APLAction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionStrictSequence, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.APLAction actions = 1; */
        for (let i = 0; i < message.actions.length; i++)
            APLAction.internalBinaryWrite(message.actions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionStrictSequence
 */
export const APLActionStrictSequence = new APLActionStrictSequence$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionChangeTarget$Type extends MessageType<APLActionChangeTarget> {
    constructor() {
        super("proto.APLActionChangeTarget", [
            { no: 1, name: "new_target", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<APLActionChangeTarget>): APLActionChangeTarget {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionChangeTarget>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionChangeTarget): APLActionChangeTarget {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference new_target */ 1:
                    message.newTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.newTarget);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionChangeTarget, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference new_target = 1; */
        if (message.newTarget)
            UnitReference.internalBinaryWrite(message.newTarget, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionChangeTarget
 */
export const APLActionChangeTarget = new APLActionChangeTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionCancelAura$Type extends MessageType<APLActionCancelAura> {
    constructor() {
        super("proto.APLActionCancelAura", [
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLActionCancelAura>): APLActionCancelAura {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionCancelAura>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionCancelAura): APLActionCancelAura {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionCancelAura, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionCancelAura
 */
export const APLActionCancelAura = new APLActionCancelAura$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionActivateAura$Type extends MessageType<APLActionActivateAura> {
    constructor() {
        super("proto.APLActionActivateAura", [
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLActionActivateAura>): APLActionActivateAura {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionActivateAura>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionActivateAura): APLActionActivateAura {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionActivateAura, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionActivateAura
 */
export const APLActionActivateAura = new APLActionActivateAura$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionTriggerICD$Type extends MessageType<APLActionTriggerICD> {
    constructor() {
        super("proto.APLActionTriggerICD", [
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLActionTriggerICD>): APLActionTriggerICD {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionTriggerICD>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionTriggerICD): APLActionTriggerICD {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionTriggerICD, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionTriggerICD
 */
export const APLActionTriggerICD = new APLActionTriggerICD$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionItemSwap$Type extends MessageType<APLActionItemSwap> {
    constructor() {
        super("proto.APLActionItemSwap", [
            { no: 1, name: "swap_set", kind: "enum", T: () => ["proto.APLActionItemSwap.SwapSet", APLActionItemSwap_SwapSet] }
        ]);
    }
    create(value?: PartialMessage<APLActionItemSwap>): APLActionItemSwap {
        const message = { swapSet: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionItemSwap>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionItemSwap): APLActionItemSwap {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLActionItemSwap.SwapSet swap_set */ 1:
                    message.swapSet = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionItemSwap, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLActionItemSwap.SwapSet swap_set = 1; */
        if (message.swapSet !== 0)
            writer.tag(1, WireType.Varint).int32(message.swapSet);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionItemSwap
 */
export const APLActionItemSwap = new APLActionItemSwap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionCatOptimalRotationAction$Type extends MessageType<APLActionCatOptimalRotationAction> {
    constructor() {
        super("proto.APLActionCatOptimalRotationAction", [
            { no: 1, name: "rotation_type", kind: "enum", T: () => ["proto.FeralDruid.Rotation.AplType", FeralDruid_Rotation_AplType] },
            { no: 2, name: "manual_params", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "max_ff_delay", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "min_roar_offset", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "rip_leeway", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "use_rake", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "use_bite", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "bite_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "flower_weave", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<APLActionCatOptimalRotationAction>): APLActionCatOptimalRotationAction {
        const message = { rotationType: 0, manualParams: false, maxFfDelay: 0, minRoarOffset: 0, ripLeeway: 0, useRake: false, useBite: false, biteTime: 0, flowerWeave: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionCatOptimalRotationAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionCatOptimalRotationAction): APLActionCatOptimalRotationAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.FeralDruid.Rotation.AplType rotation_type */ 1:
                    message.rotationType = reader.int32();
                    break;
                case /* bool manual_params */ 2:
                    message.manualParams = reader.bool();
                    break;
                case /* float max_ff_delay */ 3:
                    message.maxFfDelay = reader.float();
                    break;
                case /* float min_roar_offset */ 4:
                    message.minRoarOffset = reader.float();
                    break;
                case /* int32 rip_leeway */ 5:
                    message.ripLeeway = reader.int32();
                    break;
                case /* bool use_rake */ 6:
                    message.useRake = reader.bool();
                    break;
                case /* bool use_bite */ 7:
                    message.useBite = reader.bool();
                    break;
                case /* float bite_time */ 8:
                    message.biteTime = reader.float();
                    break;
                case /* bool flower_weave */ 9:
                    message.flowerWeave = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionCatOptimalRotationAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.FeralDruid.Rotation.AplType rotation_type = 1; */
        if (message.rotationType !== 0)
            writer.tag(1, WireType.Varint).int32(message.rotationType);
        /* bool manual_params = 2; */
        if (message.manualParams !== false)
            writer.tag(2, WireType.Varint).bool(message.manualParams);
        /* float max_ff_delay = 3; */
        if (message.maxFfDelay !== 0)
            writer.tag(3, WireType.Bit32).float(message.maxFfDelay);
        /* float min_roar_offset = 4; */
        if (message.minRoarOffset !== 0)
            writer.tag(4, WireType.Bit32).float(message.minRoarOffset);
        /* int32 rip_leeway = 5; */
        if (message.ripLeeway !== 0)
            writer.tag(5, WireType.Varint).int32(message.ripLeeway);
        /* bool use_rake = 6; */
        if (message.useRake !== false)
            writer.tag(6, WireType.Varint).bool(message.useRake);
        /* bool use_bite = 7; */
        if (message.useBite !== false)
            writer.tag(7, WireType.Varint).bool(message.useBite);
        /* float bite_time = 8; */
        if (message.biteTime !== 0)
            writer.tag(8, WireType.Bit32).float(message.biteTime);
        /* bool flower_weave = 9; */
        if (message.flowerWeave !== false)
            writer.tag(9, WireType.Varint).bool(message.flowerWeave);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionCatOptimalRotationAction
 */
export const APLActionCatOptimalRotationAction = new APLActionCatOptimalRotationAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionCustomRotation$Type extends MessageType<APLActionCustomRotation> {
    constructor() {
        super("proto.APLActionCustomRotation", []);
    }
    create(value?: PartialMessage<APLActionCustomRotation>): APLActionCustomRotation {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionCustomRotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionCustomRotation): APLActionCustomRotation {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLActionCustomRotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionCustomRotation
 */
export const APLActionCustomRotation = new APLActionCustomRotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueConst$Type extends MessageType<APLValueConst> {
    constructor() {
        super("proto.APLValueConst", [
            { no: 1, name: "val", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<APLValueConst>): APLValueConst {
        const message = { val: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueConst>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueConst): APLValueConst {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string val */ 1:
                    message.val = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueConst, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string val = 1; */
        if (message.val !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.val);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueConst
 */
export const APLValueConst = new APLValueConst$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAnd$Type extends MessageType<APLValueAnd> {
    constructor() {
        super("proto.APLValueAnd", [
            { no: 1, name: "vals", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueAnd>): APLValueAnd {
        const message = { vals: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAnd>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAnd): APLValueAnd {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.APLValue vals */ 1:
                    message.vals.push(APLValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAnd, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.APLValue vals = 1; */
        for (let i = 0; i < message.vals.length; i++)
            APLValue.internalBinaryWrite(message.vals[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAnd
 */
export const APLValueAnd = new APLValueAnd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueOr$Type extends MessageType<APLValueOr> {
    constructor() {
        super("proto.APLValueOr", [
            { no: 1, name: "vals", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueOr>): APLValueOr {
        const message = { vals: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueOr>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueOr): APLValueOr {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.APLValue vals */ 1:
                    message.vals.push(APLValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueOr, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.APLValue vals = 1; */
        for (let i = 0; i < message.vals.length; i++)
            APLValue.internalBinaryWrite(message.vals[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueOr
 */
export const APLValueOr = new APLValueOr$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueNot$Type extends MessageType<APLValueNot> {
    constructor() {
        super("proto.APLValueNot", [
            { no: 1, name: "val", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueNot>): APLValueNot {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueNot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueNot): APLValueNot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValue val */ 1:
                    message.val = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.val);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueNot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValue val = 1; */
        if (message.val)
            APLValue.internalBinaryWrite(message.val, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueNot
 */
export const APLValueNot = new APLValueNot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCompare$Type extends MessageType<APLValueCompare> {
    constructor() {
        super("proto.APLValueCompare", [
            { no: 1, name: "op", kind: "enum", T: () => ["proto.APLValueCompare.ComparisonOperator", APLValueCompare_ComparisonOperator] },
            { no: 2, name: "lhs", kind: "message", T: () => APLValue },
            { no: 3, name: "rhs", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueCompare>): APLValueCompare {
        const message = { op: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCompare>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCompare): APLValueCompare {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueCompare.ComparisonOperator op */ 1:
                    message.op = reader.int32();
                    break;
                case /* proto.APLValue lhs */ 2:
                    message.lhs = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.lhs);
                    break;
                case /* proto.APLValue rhs */ 3:
                    message.rhs = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.rhs);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCompare, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueCompare.ComparisonOperator op = 1; */
        if (message.op !== 0)
            writer.tag(1, WireType.Varint).int32(message.op);
        /* proto.APLValue lhs = 2; */
        if (message.lhs)
            APLValue.internalBinaryWrite(message.lhs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValue rhs = 3; */
        if (message.rhs)
            APLValue.internalBinaryWrite(message.rhs, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCompare
 */
export const APLValueCompare = new APLValueCompare$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueMath$Type extends MessageType<APLValueMath> {
    constructor() {
        super("proto.APLValueMath", [
            { no: 1, name: "op", kind: "enum", T: () => ["proto.APLValueMath.MathOperator", APLValueMath_MathOperator] },
            { no: 2, name: "lhs", kind: "message", T: () => APLValue },
            { no: 3, name: "rhs", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueMath>): APLValueMath {
        const message = { op: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueMath>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueMath): APLValueMath {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueMath.MathOperator op */ 1:
                    message.op = reader.int32();
                    break;
                case /* proto.APLValue lhs */ 2:
                    message.lhs = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.lhs);
                    break;
                case /* proto.APLValue rhs */ 3:
                    message.rhs = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.rhs);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueMath, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueMath.MathOperator op = 1; */
        if (message.op !== 0)
            writer.tag(1, WireType.Varint).int32(message.op);
        /* proto.APLValue lhs = 2; */
        if (message.lhs)
            APLValue.internalBinaryWrite(message.lhs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValue rhs = 3; */
        if (message.rhs)
            APLValue.internalBinaryWrite(message.rhs, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueMath
 */
export const APLValueMath = new APLValueMath$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueMax$Type extends MessageType<APLValueMax> {
    constructor() {
        super("proto.APLValueMax", [
            { no: 1, name: "vals", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueMax>): APLValueMax {
        const message = { vals: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueMax>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueMax): APLValueMax {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.APLValue vals */ 1:
                    message.vals.push(APLValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueMax, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.APLValue vals = 1; */
        for (let i = 0; i < message.vals.length; i++)
            APLValue.internalBinaryWrite(message.vals[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueMax
 */
export const APLValueMax = new APLValueMax$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueMin$Type extends MessageType<APLValueMin> {
    constructor() {
        super("proto.APLValueMin", [
            { no: 1, name: "vals", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueMin>): APLValueMin {
        const message = { vals: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueMin>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueMin): APLValueMin {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.APLValue vals */ 1:
                    message.vals.push(APLValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueMin, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.APLValue vals = 1; */
        for (let i = 0; i < message.vals.length; i++)
            APLValue.internalBinaryWrite(message.vals[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueMin
 */
export const APLValueMin = new APLValueMin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentTime$Type extends MessageType<APLValueCurrentTime> {
    constructor() {
        super("proto.APLValueCurrentTime", []);
    }
    create(value?: PartialMessage<APLValueCurrentTime>): APLValueCurrentTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentTime): APLValueCurrentTime {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCurrentTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentTime
 */
export const APLValueCurrentTime = new APLValueCurrentTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentTimePercent$Type extends MessageType<APLValueCurrentTimePercent> {
    constructor() {
        super("proto.APLValueCurrentTimePercent", []);
    }
    create(value?: PartialMessage<APLValueCurrentTimePercent>): APLValueCurrentTimePercent {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentTimePercent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentTimePercent): APLValueCurrentTimePercent {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCurrentTimePercent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentTimePercent
 */
export const APLValueCurrentTimePercent = new APLValueCurrentTimePercent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueRemainingTime$Type extends MessageType<APLValueRemainingTime> {
    constructor() {
        super("proto.APLValueRemainingTime", []);
    }
    create(value?: PartialMessage<APLValueRemainingTime>): APLValueRemainingTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueRemainingTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueRemainingTime): APLValueRemainingTime {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueRemainingTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueRemainingTime
 */
export const APLValueRemainingTime = new APLValueRemainingTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueRemainingTimePercent$Type extends MessageType<APLValueRemainingTimePercent> {
    constructor() {
        super("proto.APLValueRemainingTimePercent", []);
    }
    create(value?: PartialMessage<APLValueRemainingTimePercent>): APLValueRemainingTimePercent {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueRemainingTimePercent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueRemainingTimePercent): APLValueRemainingTimePercent {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueRemainingTimePercent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueRemainingTimePercent
 */
export const APLValueRemainingTimePercent = new APLValueRemainingTimePercent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueNumberTargets$Type extends MessageType<APLValueNumberTargets> {
    constructor() {
        super("proto.APLValueNumberTargets", []);
    }
    create(value?: PartialMessage<APLValueNumberTargets>): APLValueNumberTargets {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueNumberTargets>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueNumberTargets): APLValueNumberTargets {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueNumberTargets, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueNumberTargets
 */
export const APLValueNumberTargets = new APLValueNumberTargets$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueIsExecutePhase$Type extends MessageType<APLValueIsExecutePhase> {
    constructor() {
        super("proto.APLValueIsExecutePhase", [
            { no: 1, name: "threshold", kind: "enum", T: () => ["proto.APLValueIsExecutePhase.ExecutePhaseThreshold", APLValueIsExecutePhase_ExecutePhaseThreshold] }
        ]);
    }
    create(value?: PartialMessage<APLValueIsExecutePhase>): APLValueIsExecutePhase {
        const message = { threshold: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueIsExecutePhase>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueIsExecutePhase): APLValueIsExecutePhase {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueIsExecutePhase.ExecutePhaseThreshold threshold */ 1:
                    message.threshold = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueIsExecutePhase, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueIsExecutePhase.ExecutePhaseThreshold threshold = 1; */
        if (message.threshold !== 0)
            writer.tag(1, WireType.Varint).int32(message.threshold);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueIsExecutePhase
 */
export const APLValueIsExecutePhase = new APLValueIsExecutePhase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueBossSpellTimeToReady$Type extends MessageType<APLValueBossSpellTimeToReady> {
    constructor() {
        super("proto.APLValueBossSpellTimeToReady", [
            { no: 1, name: "target_unit", kind: "message", T: () => UnitReference },
            { no: 2, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueBossSpellTimeToReady>): APLValueBossSpellTimeToReady {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueBossSpellTimeToReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueBossSpellTimeToReady): APLValueBossSpellTimeToReady {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference target_unit */ 1:
                    message.targetUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.targetUnit);
                    break;
                case /* proto.ActionID spell_id */ 2:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueBossSpellTimeToReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference target_unit = 1; */
        if (message.targetUnit)
            UnitReference.internalBinaryWrite(message.targetUnit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID spell_id = 2; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueBossSpellTimeToReady
 */
export const APLValueBossSpellTimeToReady = new APLValueBossSpellTimeToReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueBossSpellIsCasting$Type extends MessageType<APLValueBossSpellIsCasting> {
    constructor() {
        super("proto.APLValueBossSpellIsCasting", [
            { no: 1, name: "target_unit", kind: "message", T: () => UnitReference },
            { no: 2, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueBossSpellIsCasting>): APLValueBossSpellIsCasting {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueBossSpellIsCasting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueBossSpellIsCasting): APLValueBossSpellIsCasting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference target_unit */ 1:
                    message.targetUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.targetUnit);
                    break;
                case /* proto.ActionID spell_id */ 2:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueBossSpellIsCasting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference target_unit = 1; */
        if (message.targetUnit)
            UnitReference.internalBinaryWrite(message.targetUnit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID spell_id = 2; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueBossSpellIsCasting
 */
export const APLValueBossSpellIsCasting = new APLValueBossSpellIsCasting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentHealth$Type extends MessageType<APLValueCurrentHealth> {
    constructor() {
        super("proto.APLValueCurrentHealth", [
            { no: 1, name: "source_unit", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentHealth>): APLValueCurrentHealth {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentHealth>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentHealth): APLValueCurrentHealth {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 1:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentHealth, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 1; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentHealth
 */
export const APLValueCurrentHealth = new APLValueCurrentHealth$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentHealthPercent$Type extends MessageType<APLValueCurrentHealthPercent> {
    constructor() {
        super("proto.APLValueCurrentHealthPercent", [
            { no: 1, name: "source_unit", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentHealthPercent>): APLValueCurrentHealthPercent {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentHealthPercent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentHealthPercent): APLValueCurrentHealthPercent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 1:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentHealthPercent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 1; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentHealthPercent
 */
export const APLValueCurrentHealthPercent = new APLValueCurrentHealthPercent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentMana$Type extends MessageType<APLValueCurrentMana> {
    constructor() {
        super("proto.APLValueCurrentMana", [
            { no: 1, name: "source_unit", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentMana>): APLValueCurrentMana {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentMana>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentMana): APLValueCurrentMana {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 1:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentMana, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 1; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentMana
 */
export const APLValueCurrentMana = new APLValueCurrentMana$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentManaPercent$Type extends MessageType<APLValueCurrentManaPercent> {
    constructor() {
        super("proto.APLValueCurrentManaPercent", [
            { no: 1, name: "source_unit", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentManaPercent>): APLValueCurrentManaPercent {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentManaPercent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentManaPercent): APLValueCurrentManaPercent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 1:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentManaPercent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 1; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentManaPercent
 */
export const APLValueCurrentManaPercent = new APLValueCurrentManaPercent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentRage$Type extends MessageType<APLValueCurrentRage> {
    constructor() {
        super("proto.APLValueCurrentRage", []);
    }
    create(value?: PartialMessage<APLValueCurrentRage>): APLValueCurrentRage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentRage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentRage): APLValueCurrentRage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCurrentRage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentRage
 */
export const APLValueCurrentRage = new APLValueCurrentRage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentEnergy$Type extends MessageType<APLValueCurrentEnergy> {
    constructor() {
        super("proto.APLValueCurrentEnergy", []);
    }
    create(value?: PartialMessage<APLValueCurrentEnergy>): APLValueCurrentEnergy {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentEnergy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentEnergy): APLValueCurrentEnergy {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCurrentEnergy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentEnergy
 */
export const APLValueCurrentEnergy = new APLValueCurrentEnergy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentComboPoints$Type extends MessageType<APLValueCurrentComboPoints> {
    constructor() {
        super("proto.APLValueCurrentComboPoints", []);
    }
    create(value?: PartialMessage<APLValueCurrentComboPoints>): APLValueCurrentComboPoints {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentComboPoints>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentComboPoints): APLValueCurrentComboPoints {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCurrentComboPoints, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentComboPoints
 */
export const APLValueCurrentComboPoints = new APLValueCurrentComboPoints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentRunicPower$Type extends MessageType<APLValueCurrentRunicPower> {
    constructor() {
        super("proto.APLValueCurrentRunicPower", []);
    }
    create(value?: PartialMessage<APLValueCurrentRunicPower>): APLValueCurrentRunicPower {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentRunicPower>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentRunicPower): APLValueCurrentRunicPower {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCurrentRunicPower, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentRunicPower
 */
export const APLValueCurrentRunicPower = new APLValueCurrentRunicPower$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentRuneCount$Type extends MessageType<APLValueCurrentRuneCount> {
    constructor() {
        super("proto.APLValueCurrentRuneCount", [
            { no: 1, name: "rune_type", kind: "enum", T: () => ["proto.APLValueRuneType", APLValueRuneType] }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentRuneCount>): APLValueCurrentRuneCount {
        const message = { runeType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentRuneCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentRuneCount): APLValueCurrentRuneCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneType rune_type */ 1:
                    message.runeType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentRuneCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneType rune_type = 1; */
        if (message.runeType !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentRuneCount
 */
export const APLValueCurrentRuneCount = new APLValueCurrentRuneCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentNonDeathRuneCount$Type extends MessageType<APLValueCurrentNonDeathRuneCount> {
    constructor() {
        super("proto.APLValueCurrentNonDeathRuneCount", [
            { no: 1, name: "rune_type", kind: "enum", T: () => ["proto.APLValueRuneType", APLValueRuneType] }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentNonDeathRuneCount>): APLValueCurrentNonDeathRuneCount {
        const message = { runeType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentNonDeathRuneCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentNonDeathRuneCount): APLValueCurrentNonDeathRuneCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneType rune_type */ 1:
                    message.runeType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentNonDeathRuneCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneType rune_type = 1; */
        if (message.runeType !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentNonDeathRuneCount
 */
export const APLValueCurrentNonDeathRuneCount = new APLValueCurrentNonDeathRuneCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentRuneDeath$Type extends MessageType<APLValueCurrentRuneDeath> {
    constructor() {
        super("proto.APLValueCurrentRuneDeath", [
            { no: 1, name: "rune_slot", kind: "enum", T: () => ["proto.APLValueRuneSlot", APLValueRuneSlot] }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentRuneDeath>): APLValueCurrentRuneDeath {
        const message = { runeSlot: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentRuneDeath>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentRuneDeath): APLValueCurrentRuneDeath {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneSlot rune_slot */ 1:
                    message.runeSlot = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentRuneDeath, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneSlot rune_slot = 1; */
        if (message.runeSlot !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeSlot);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentRuneDeath
 */
export const APLValueCurrentRuneDeath = new APLValueCurrentRuneDeath$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCurrentRuneActive$Type extends MessageType<APLValueCurrentRuneActive> {
    constructor() {
        super("proto.APLValueCurrentRuneActive", [
            { no: 1, name: "rune_slot", kind: "enum", T: () => ["proto.APLValueRuneSlot", APLValueRuneSlot] }
        ]);
    }
    create(value?: PartialMessage<APLValueCurrentRuneActive>): APLValueCurrentRuneActive {
        const message = { runeSlot: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCurrentRuneActive>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCurrentRuneActive): APLValueCurrentRuneActive {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneSlot rune_slot */ 1:
                    message.runeSlot = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueCurrentRuneActive, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneSlot rune_slot = 1; */
        if (message.runeSlot !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeSlot);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCurrentRuneActive
 */
export const APLValueCurrentRuneActive = new APLValueCurrentRuneActive$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueRuneCooldown$Type extends MessageType<APLValueRuneCooldown> {
    constructor() {
        super("proto.APLValueRuneCooldown", [
            { no: 1, name: "rune_type", kind: "enum", T: () => ["proto.APLValueRuneType", APLValueRuneType] }
        ]);
    }
    create(value?: PartialMessage<APLValueRuneCooldown>): APLValueRuneCooldown {
        const message = { runeType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueRuneCooldown>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueRuneCooldown): APLValueRuneCooldown {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneType rune_type */ 1:
                    message.runeType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueRuneCooldown, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneType rune_type = 1; */
        if (message.runeType !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueRuneCooldown
 */
export const APLValueRuneCooldown = new APLValueRuneCooldown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueNextRuneCooldown$Type extends MessageType<APLValueNextRuneCooldown> {
    constructor() {
        super("proto.APLValueNextRuneCooldown", [
            { no: 1, name: "rune_type", kind: "enum", T: () => ["proto.APLValueRuneType", APLValueRuneType] }
        ]);
    }
    create(value?: PartialMessage<APLValueNextRuneCooldown>): APLValueNextRuneCooldown {
        const message = { runeType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueNextRuneCooldown>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueNextRuneCooldown): APLValueNextRuneCooldown {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneType rune_type */ 1:
                    message.runeType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueNextRuneCooldown, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneType rune_type = 1; */
        if (message.runeType !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueNextRuneCooldown
 */
export const APLValueNextRuneCooldown = new APLValueNextRuneCooldown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueRuneSlotCooldown$Type extends MessageType<APLValueRuneSlotCooldown> {
    constructor() {
        super("proto.APLValueRuneSlotCooldown", [
            { no: 1, name: "rune_slot", kind: "enum", T: () => ["proto.APLValueRuneSlot", APLValueRuneSlot] }
        ]);
    }
    create(value?: PartialMessage<APLValueRuneSlotCooldown>): APLValueRuneSlotCooldown {
        const message = { runeSlot: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueRuneSlotCooldown>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueRuneSlotCooldown): APLValueRuneSlotCooldown {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneSlot rune_slot */ 1:
                    message.runeSlot = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueRuneSlotCooldown, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneSlot rune_slot = 1; */
        if (message.runeSlot !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeSlot);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueRuneSlotCooldown
 */
export const APLValueRuneSlotCooldown = new APLValueRuneSlotCooldown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueRuneGrace$Type extends MessageType<APLValueRuneGrace> {
    constructor() {
        super("proto.APLValueRuneGrace", [
            { no: 1, name: "rune_type", kind: "enum", T: () => ["proto.APLValueRuneType", APLValueRuneType] }
        ]);
    }
    create(value?: PartialMessage<APLValueRuneGrace>): APLValueRuneGrace {
        const message = { runeType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueRuneGrace>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueRuneGrace): APLValueRuneGrace {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneType rune_type */ 1:
                    message.runeType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueRuneGrace, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneType rune_type = 1; */
        if (message.runeType !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueRuneGrace
 */
export const APLValueRuneGrace = new APLValueRuneGrace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueRuneSlotGrace$Type extends MessageType<APLValueRuneSlotGrace> {
    constructor() {
        super("proto.APLValueRuneSlotGrace", [
            { no: 1, name: "rune_slot", kind: "enum", T: () => ["proto.APLValueRuneType", APLValueRuneType] }
        ]);
    }
    create(value?: PartialMessage<APLValueRuneSlotGrace>): APLValueRuneSlotGrace {
        const message = { runeSlot: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueRuneSlotGrace>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueRuneSlotGrace): APLValueRuneSlotGrace {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLValueRuneType rune_slot */ 1:
                    message.runeSlot = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueRuneSlotGrace, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLValueRuneType rune_slot = 1; */
        if (message.runeSlot !== 0)
            writer.tag(1, WireType.Varint).int32(message.runeSlot);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueRuneSlotGrace
 */
export const APLValueRuneSlotGrace = new APLValueRuneSlotGrace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueGCDIsReady$Type extends MessageType<APLValueGCDIsReady> {
    constructor() {
        super("proto.APLValueGCDIsReady", []);
    }
    create(value?: PartialMessage<APLValueGCDIsReady>): APLValueGCDIsReady {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueGCDIsReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueGCDIsReady): APLValueGCDIsReady {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueGCDIsReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueGCDIsReady
 */
export const APLValueGCDIsReady = new APLValueGCDIsReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueGCDTimeToReady$Type extends MessageType<APLValueGCDTimeToReady> {
    constructor() {
        super("proto.APLValueGCDTimeToReady", []);
    }
    create(value?: PartialMessage<APLValueGCDTimeToReady>): APLValueGCDTimeToReady {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueGCDTimeToReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueGCDTimeToReady): APLValueGCDTimeToReady {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueGCDTimeToReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueGCDTimeToReady
 */
export const APLValueGCDTimeToReady = new APLValueGCDTimeToReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAutoTimeToNext$Type extends MessageType<APLValueAutoTimeToNext> {
    constructor() {
        super("proto.APLValueAutoTimeToNext", []);
    }
    create(value?: PartialMessage<APLValueAutoTimeToNext>): APLValueAutoTimeToNext {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAutoTimeToNext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAutoTimeToNext): APLValueAutoTimeToNext {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueAutoTimeToNext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAutoTimeToNext
 */
export const APLValueAutoTimeToNext = new APLValueAutoTimeToNext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellCanCast$Type extends MessageType<APLValueSpellCanCast> {
    constructor() {
        super("proto.APLValueSpellCanCast", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellCanCast>): APLValueSpellCanCast {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellCanCast>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellCanCast): APLValueSpellCanCast {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellCanCast, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellCanCast
 */
export const APLValueSpellCanCast = new APLValueSpellCanCast$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellIsReady$Type extends MessageType<APLValueSpellIsReady> {
    constructor() {
        super("proto.APLValueSpellIsReady", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellIsReady>): APLValueSpellIsReady {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellIsReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellIsReady): APLValueSpellIsReady {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellIsReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellIsReady
 */
export const APLValueSpellIsReady = new APLValueSpellIsReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellTimeToReady$Type extends MessageType<APLValueSpellTimeToReady> {
    constructor() {
        super("proto.APLValueSpellTimeToReady", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellTimeToReady>): APLValueSpellTimeToReady {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellTimeToReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellTimeToReady): APLValueSpellTimeToReady {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellTimeToReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellTimeToReady
 */
export const APLValueSpellTimeToReady = new APLValueSpellTimeToReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellCastTime$Type extends MessageType<APLValueSpellCastTime> {
    constructor() {
        super("proto.APLValueSpellCastTime", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellCastTime>): APLValueSpellCastTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellCastTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellCastTime): APLValueSpellCastTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellCastTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellCastTime
 */
export const APLValueSpellCastTime = new APLValueSpellCastTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueChannelClipDelay$Type extends MessageType<APLValueChannelClipDelay> {
    constructor() {
        super("proto.APLValueChannelClipDelay", []);
    }
    create(value?: PartialMessage<APLValueChannelClipDelay>): APLValueChannelClipDelay {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueChannelClipDelay>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueChannelClipDelay): APLValueChannelClipDelay {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueChannelClipDelay, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueChannelClipDelay
 */
export const APLValueChannelClipDelay = new APLValueChannelClipDelay$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueFrontOfTarget$Type extends MessageType<APLValueFrontOfTarget> {
    constructor() {
        super("proto.APLValueFrontOfTarget", []);
    }
    create(value?: PartialMessage<APLValueFrontOfTarget>): APLValueFrontOfTarget {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueFrontOfTarget>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueFrontOfTarget): APLValueFrontOfTarget {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueFrontOfTarget, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueFrontOfTarget
 */
export const APLValueFrontOfTarget = new APLValueFrontOfTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellTravelTime$Type extends MessageType<APLValueSpellTravelTime> {
    constructor() {
        super("proto.APLValueSpellTravelTime", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellTravelTime>): APLValueSpellTravelTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellTravelTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellTravelTime): APLValueSpellTravelTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellTravelTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellTravelTime
 */
export const APLValueSpellTravelTime = new APLValueSpellTravelTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellCPM$Type extends MessageType<APLValueSpellCPM> {
    constructor() {
        super("proto.APLValueSpellCPM", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellCPM>): APLValueSpellCPM {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellCPM>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellCPM): APLValueSpellCPM {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellCPM, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellCPM
 */
export const APLValueSpellCPM = new APLValueSpellCPM$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellIsChanneling$Type extends MessageType<APLValueSpellIsChanneling> {
    constructor() {
        super("proto.APLValueSpellIsChanneling", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellIsChanneling>): APLValueSpellIsChanneling {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellIsChanneling>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellIsChanneling): APLValueSpellIsChanneling {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellIsChanneling, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellIsChanneling
 */
export const APLValueSpellIsChanneling = new APLValueSpellIsChanneling$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellChanneledTicks$Type extends MessageType<APLValueSpellChanneledTicks> {
    constructor() {
        super("proto.APLValueSpellChanneledTicks", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellChanneledTicks>): APLValueSpellChanneledTicks {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellChanneledTicks>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellChanneledTicks): APLValueSpellChanneledTicks {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellChanneledTicks, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellChanneledTicks
 */
export const APLValueSpellChanneledTicks = new APLValueSpellChanneledTicks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSpellCurrentCost$Type extends MessageType<APLValueSpellCurrentCost> {
    constructor() {
        super("proto.APLValueSpellCurrentCost", [
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueSpellCurrentCost>): APLValueSpellCurrentCost {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSpellCurrentCost>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSpellCurrentCost): APLValueSpellCurrentCost {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSpellCurrentCost, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSpellCurrentCost
 */
export const APLValueSpellCurrentCost = new APLValueSpellCurrentCost$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAuraIsActive$Type extends MessageType<APLValueAuraIsActive> {
    constructor() {
        super("proto.APLValueAuraIsActive", [
            { no: 2, name: "source_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueAuraIsActive>): APLValueAuraIsActive {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAuraIsActive>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAuraIsActive): APLValueAuraIsActive {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 2:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAuraIsActive, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 2; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAuraIsActive
 */
export const APLValueAuraIsActive = new APLValueAuraIsActive$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAuraIsActiveWithReactionTime$Type extends MessageType<APLValueAuraIsActiveWithReactionTime> {
    constructor() {
        super("proto.APLValueAuraIsActiveWithReactionTime", [
            { no: 2, name: "source_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueAuraIsActiveWithReactionTime>): APLValueAuraIsActiveWithReactionTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAuraIsActiveWithReactionTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAuraIsActiveWithReactionTime): APLValueAuraIsActiveWithReactionTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 2:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAuraIsActiveWithReactionTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 2; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAuraIsActiveWithReactionTime
 */
export const APLValueAuraIsActiveWithReactionTime = new APLValueAuraIsActiveWithReactionTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAuraRemainingTime$Type extends MessageType<APLValueAuraRemainingTime> {
    constructor() {
        super("proto.APLValueAuraRemainingTime", [
            { no: 2, name: "source_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueAuraRemainingTime>): APLValueAuraRemainingTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAuraRemainingTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAuraRemainingTime): APLValueAuraRemainingTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 2:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAuraRemainingTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 2; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAuraRemainingTime
 */
export const APLValueAuraRemainingTime = new APLValueAuraRemainingTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAuraNumStacks$Type extends MessageType<APLValueAuraNumStacks> {
    constructor() {
        super("proto.APLValueAuraNumStacks", [
            { no: 2, name: "source_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueAuraNumStacks>): APLValueAuraNumStacks {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAuraNumStacks>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAuraNumStacks): APLValueAuraNumStacks {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 2:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAuraNumStacks, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 2; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAuraNumStacks
 */
export const APLValueAuraNumStacks = new APLValueAuraNumStacks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAuraInternalCooldown$Type extends MessageType<APLValueAuraInternalCooldown> {
    constructor() {
        super("proto.APLValueAuraInternalCooldown", [
            { no: 2, name: "source_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueAuraInternalCooldown>): APLValueAuraInternalCooldown {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAuraInternalCooldown>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAuraInternalCooldown): APLValueAuraInternalCooldown {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 2:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAuraInternalCooldown, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 2; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAuraInternalCooldown
 */
export const APLValueAuraInternalCooldown = new APLValueAuraInternalCooldown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAuraICDIsReadyWithReactionTime$Type extends MessageType<APLValueAuraICDIsReadyWithReactionTime> {
    constructor() {
        super("proto.APLValueAuraICDIsReadyWithReactionTime", [
            { no: 2, name: "source_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueAuraICDIsReadyWithReactionTime>): APLValueAuraICDIsReadyWithReactionTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAuraICDIsReadyWithReactionTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAuraICDIsReadyWithReactionTime): APLValueAuraICDIsReadyWithReactionTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 2:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAuraICDIsReadyWithReactionTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 2; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAuraICDIsReadyWithReactionTime
 */
export const APLValueAuraICDIsReadyWithReactionTime = new APLValueAuraICDIsReadyWithReactionTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueAuraShouldRefresh$Type extends MessageType<APLValueAuraShouldRefresh> {
    constructor() {
        super("proto.APLValueAuraShouldRefresh", [
            { no: 2, name: "source_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "aura_id", kind: "message", T: () => ActionID },
            { no: 3, name: "max_overlap", kind: "message", T: () => APLValue }
        ]);
    }
    create(value?: PartialMessage<APLValueAuraShouldRefresh>): APLValueAuraShouldRefresh {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueAuraShouldRefresh>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueAuraShouldRefresh): APLValueAuraShouldRefresh {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference source_unit */ 2:
                    message.sourceUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.sourceUnit);
                    break;
                case /* proto.ActionID aura_id */ 1:
                    message.auraId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.auraId);
                    break;
                case /* proto.APLValue max_overlap */ 3:
                    message.maxOverlap = APLValue.internalBinaryRead(reader, reader.uint32(), options, message.maxOverlap);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueAuraShouldRefresh, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference source_unit = 2; */
        if (message.sourceUnit)
            UnitReference.internalBinaryWrite(message.sourceUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID aura_id = 1; */
        if (message.auraId)
            ActionID.internalBinaryWrite(message.auraId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLValue max_overlap = 3; */
        if (message.maxOverlap)
            APLValue.internalBinaryWrite(message.maxOverlap, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueAuraShouldRefresh
 */
export const APLValueAuraShouldRefresh = new APLValueAuraShouldRefresh$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueDotIsActive$Type extends MessageType<APLValueDotIsActive> {
    constructor() {
        super("proto.APLValueDotIsActive", [
            { no: 2, name: "target_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueDotIsActive>): APLValueDotIsActive {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueDotIsActive>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueDotIsActive): APLValueDotIsActive {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference target_unit */ 2:
                    message.targetUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.targetUnit);
                    break;
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueDotIsActive, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference target_unit = 2; */
        if (message.targetUnit)
            UnitReference.internalBinaryWrite(message.targetUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueDotIsActive
 */
export const APLValueDotIsActive = new APLValueDotIsActive$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueDotRemainingTime$Type extends MessageType<APLValueDotRemainingTime> {
    constructor() {
        super("proto.APLValueDotRemainingTime", [
            { no: 2, name: "target_unit", kind: "message", T: () => UnitReference },
            { no: 1, name: "spell_id", kind: "message", T: () => ActionID }
        ]);
    }
    create(value?: PartialMessage<APLValueDotRemainingTime>): APLValueDotRemainingTime {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueDotRemainingTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueDotRemainingTime): APLValueDotRemainingTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference target_unit */ 2:
                    message.targetUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.targetUnit);
                    break;
                case /* proto.ActionID spell_id */ 1:
                    message.spellId = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.spellId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueDotRemainingTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference target_unit = 2; */
        if (message.targetUnit)
            UnitReference.internalBinaryWrite(message.targetUnit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ActionID spell_id = 1; */
        if (message.spellId)
            ActionID.internalBinaryWrite(message.spellId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueDotRemainingTime
 */
export const APLValueDotRemainingTime = new APLValueDotRemainingTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSequenceIsComplete$Type extends MessageType<APLValueSequenceIsComplete> {
    constructor() {
        super("proto.APLValueSequenceIsComplete", [
            { no: 1, name: "sequence_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<APLValueSequenceIsComplete>): APLValueSequenceIsComplete {
        const message = { sequenceName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSequenceIsComplete>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSequenceIsComplete): APLValueSequenceIsComplete {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sequence_name */ 1:
                    message.sequenceName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSequenceIsComplete, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sequence_name = 1; */
        if (message.sequenceName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sequenceName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSequenceIsComplete
 */
export const APLValueSequenceIsComplete = new APLValueSequenceIsComplete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSequenceIsReady$Type extends MessageType<APLValueSequenceIsReady> {
    constructor() {
        super("proto.APLValueSequenceIsReady", [
            { no: 1, name: "sequence_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<APLValueSequenceIsReady>): APLValueSequenceIsReady {
        const message = { sequenceName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSequenceIsReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSequenceIsReady): APLValueSequenceIsReady {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sequence_name */ 1:
                    message.sequenceName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSequenceIsReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sequence_name = 1; */
        if (message.sequenceName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sequenceName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSequenceIsReady
 */
export const APLValueSequenceIsReady = new APLValueSequenceIsReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueSequenceTimeToReady$Type extends MessageType<APLValueSequenceTimeToReady> {
    constructor() {
        super("proto.APLValueSequenceTimeToReady", [
            { no: 1, name: "sequence_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<APLValueSequenceTimeToReady>): APLValueSequenceTimeToReady {
        const message = { sequenceName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueSequenceTimeToReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueSequenceTimeToReady): APLValueSequenceTimeToReady {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sequence_name */ 1:
                    message.sequenceName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueSequenceTimeToReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sequence_name = 1; */
        if (message.sequenceName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sequenceName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueSequenceTimeToReady
 */
export const APLValueSequenceTimeToReady = new APLValueSequenceTimeToReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueTotemRemainingTime$Type extends MessageType<APLValueTotemRemainingTime> {
    constructor() {
        super("proto.APLValueTotemRemainingTime", [
            { no: 1, name: "totem_type", kind: "enum", T: () => ["proto.ShamanTotems.TotemType", ShamanTotems_TotemType] }
        ]);
    }
    create(value?: PartialMessage<APLValueTotemRemainingTime>): APLValueTotemRemainingTime {
        const message = { totemType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueTotemRemainingTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueTotemRemainingTime): APLValueTotemRemainingTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ShamanTotems.TotemType totem_type */ 1:
                    message.totemType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueTotemRemainingTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ShamanTotems.TotemType totem_type = 1; */
        if (message.totemType !== 0)
            writer.tag(1, WireType.Varint).int32(message.totemType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueTotemRemainingTime
 */
export const APLValueTotemRemainingTime = new APLValueTotemRemainingTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCatExcessEnergy$Type extends MessageType<APLValueCatExcessEnergy> {
    constructor() {
        super("proto.APLValueCatExcessEnergy", []);
    }
    create(value?: PartialMessage<APLValueCatExcessEnergy>): APLValueCatExcessEnergy {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCatExcessEnergy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCatExcessEnergy): APLValueCatExcessEnergy {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCatExcessEnergy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCatExcessEnergy
 */
export const APLValueCatExcessEnergy = new APLValueCatExcessEnergy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueCatNewSavageRoarDuration$Type extends MessageType<APLValueCatNewSavageRoarDuration> {
    constructor() {
        super("proto.APLValueCatNewSavageRoarDuration", []);
    }
    create(value?: PartialMessage<APLValueCatNewSavageRoarDuration>): APLValueCatNewSavageRoarDuration {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueCatNewSavageRoarDuration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueCatNewSavageRoarDuration): APLValueCatNewSavageRoarDuration {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueCatNewSavageRoarDuration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueCatNewSavageRoarDuration
 */
export const APLValueCatNewSavageRoarDuration = new APLValueCatNewSavageRoarDuration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueWarlockShouldRecastDrainSoul$Type extends MessageType<APLValueWarlockShouldRecastDrainSoul> {
    constructor() {
        super("proto.APLValueWarlockShouldRecastDrainSoul", []);
    }
    create(value?: PartialMessage<APLValueWarlockShouldRecastDrainSoul>): APLValueWarlockShouldRecastDrainSoul {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueWarlockShouldRecastDrainSoul>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueWarlockShouldRecastDrainSoul): APLValueWarlockShouldRecastDrainSoul {
        return target ?? this.create();
    }
    internalBinaryWrite(message: APLValueWarlockShouldRecastDrainSoul, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueWarlockShouldRecastDrainSoul
 */
export const APLValueWarlockShouldRecastDrainSoul = new APLValueWarlockShouldRecastDrainSoul$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLValueWarlockShouldRefreshCorruption$Type extends MessageType<APLValueWarlockShouldRefreshCorruption> {
    constructor() {
        super("proto.APLValueWarlockShouldRefreshCorruption", [
            { no: 1, name: "target_unit", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<APLValueWarlockShouldRefreshCorruption>): APLValueWarlockShouldRefreshCorruption {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLValueWarlockShouldRefreshCorruption>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLValueWarlockShouldRefreshCorruption): APLValueWarlockShouldRefreshCorruption {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference target_unit */ 1:
                    message.targetUnit = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.targetUnit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLValueWarlockShouldRefreshCorruption, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference target_unit = 1; */
        if (message.targetUnit)
            UnitReference.internalBinaryWrite(message.targetUnit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLValueWarlockShouldRefreshCorruption
 */
export const APLValueWarlockShouldRefreshCorruption = new APLValueWarlockShouldRefreshCorruption$Type();
